import React, { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Chip,
  Grid,
  Select,
  MenuItem,
  FormControl,
  Skeleton,
  useMediaQuery,
  useTheme,
  Stepper,
  Step,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { IconButton as MUIIconButton } from "@mui/material";
import { IconButton, UploadButton } from "../../components/ui/Button";
import CustomDivider from "../../components/common/CustomDivider";
import UploadIcon from "./../../assets/svgIcons/upload.svg";
import ViewIcon from "./../../assets/svgIcons/eye.svg";
import LockSquare from "./../../assets/svgIcons/lock-square.svg";
import textFile from "./../../assets/images/icons/file-text.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUserApplications,
  fetchUserApplicationsFormData,
} from "../../services/api/service/userApplicationService";
import { TruncatedTextWithTooltip } from "../../components/ui/TruncatedTextWithTooltip";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Breadcrumbs from "../../components/ui/Breadcrumbs";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DetailRow from "../common-features/DetailRow";
import {
  setActiveHorizontalIndex,
  setActiveVerticalIndex,
  setIsEligibilityCheckSubmitted,
  setHasCheckedInitialSummary,
  setIsMobileVerified,
  setIsEmailVerified,
  setLastVerifiedEmail,
  setLastVerifiedPhoneNumber,
  updateFormData,
  clearFormData,
  setTrackingId,
  setCollateralId,
  setreferenceOneId,
  setreferenceTwoId,
  setIsDocumentVerified,
  clearActiveIndex,
  setIsPanVerified,
  setPanNumber,
  setAadhaarMandatory,
  setShowAadhaar,
  setHasPan,
  setCoApplicantVerification,
  setCompletedHorizontalIndex,
  setBreStatus,
  clearCoApplicantVerification,
  clearIsDocumentVerifiedCoApplicant,
  clearAadhaarApplicationNoCoApplicant,
  clearAadhaarVerifiedDetailsCoApplicant,
  clearAadhaarVerifiedDetails,
  setLastPanNumber,
  setCheckIsLeadApiInvoked,
  setApplicationId,
  setApplicantId,
  setLeadSequenceId,
  setAssignedSMIdValue,
  setDisplayHorizontalSteps,
  setDocumentApplicantType,
  setAadhaarSeedingStatus,
  setIsEligible,
  setApplicationSource,
  setDisableAddMoreCoApplicant,
  setSavedBasicForCoApplicant,
  clearSavedBasicCoApplicants,
  clearNotInList,
  setNotInList,
  setCustomerConsentTime,
  setFetchUserApplicationData,
  setHorizontalSteps,
} from "../../services/redux/slices/stepperDynamicFormSlice";
import { setStatusPopup } from "../../services/redux/slices/statusPopupSlice";
import { formatDateToShortMonth } from "../../utils/dateFormatUtils";
import eligibilityCheckServices from "../../services/api/service/eligibilityCheckService";
import ApplicationProgressStepper from "../../components/common/ApplicationProgressStepper";
import {
  setChatStatusConfig,
  setCurrentSessionId,
  setSalesUserId,
} from "../../services/redux/slices/chatSlice";
import {
  getCombinedApplicationSteps,
  getGAExistingApplicationStatements,
  getReferenceData,
} from "../../components/ui/StepperDyanmicForm/helper";
import { AppDispatch, RootState } from "../../services/redux/store";
import { clearAllApplicantLoanDetails, setCoApplicantDetails } from "../../services/redux/slices/applicationLoanDetailsSlice";
import {
  setOpenFirstTimeOnlyPopup,
} from "../../services/redux/slices/tabsSlice";
import { getApplicationMessage, gotoPageStepOrLoanOverviewPage, isDeviceTypeMobile, normalize,findApplicantStep, getCoApplicantList } from "../../utils/helpers";
import { APP_STATUS, STATUS_MESSAGES } from "../../utils/journeyConstants";
import { InfoOutlined } from "@mui/icons-material";
import { getFormJson } from "../../services/redux/thunks/stepperDynamicFormThunks";
import { decrypt } from "../../utils/crypto";
import { trackCustomerJourneyEvent } from "../../utils/ga";
import { authSelector,authStatusSelector } from "../../services/redux/slices/authSlice";
import { checkUndecided } from "./ExistingApplication";
import CrmIdChip from "../../components/crmChip";
import NextStepBanner from "../../components/ui/NextStepBanner";
import SalesManagerContact from "../../components/ui/SalesManagerContact";

// --- Types (Updated for dynamic verticalStepsCount in HorizontalStep) ---
interface ApplicationCardProps {
  application: Application;
  finalSteps: CombinedStep[];
  activeStep: number;
  isXsOrSm: boolean;
  isIphoneSE: boolean;
  breData: any;
  isSliderLoading: boolean;
  leadDetailsData: any;
  sanctionDetailsData?: any;
  provisionalOffer?: string;
}
interface Field {
  [key: string]: any;
}

interface VerticalStep {
  fields: Field[];
}
interface HorizontalStep {
  horizontalStepName: string;
  verticalStepsCount: number;
  verticalSteps: VerticalStep[];
  completionRate?: number;
}
interface Application {
  horizontalSteps: HorizontalStep[];
  submissionId: string;
  createdAt: string;
  updatedAt: string;
  status?: string;
  assignedSMId?: string;
  assignedSMName?: string;
  assignedSMEmail?: string;
  assignedSMMobileNumber?: string;
  partnerStartedJourney?: boolean;
  applicationId?: any;
  partnerName?: string;
  isEligibilityChecked: any;
  isProvisionalGenerated?: boolean;
  collateralId:number|null;
  referenceOneId:number|null;
  referenceTwoId:number|null;
  externalId?: string;
}
interface CombinedStep {
  label: string;
  completionRate: number;
  status: "pending" | "completed" | "inprogress";
  isActive: boolean;
  isCompleted: boolean;
  isProvisionalGenerated?: boolean;
  isQualified?: boolean;
  isEligible?: any;
}

const normalizeStepName = (value: any): string =>
  String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

const normalizeCompletionRate = (value: any): number => {
  if (typeof value === "number") return value;
  if (typeof value === "string") {
    const parsed = Number(String(value).replace(/%/g, "").trim());
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};

// const isStepCompleted = (step: any): boolean => {
//   const status = String(step?.status || "").toLowerCase();
//   return status === "completed" || normalizeCompletionRate(step?.completionRate) >= 100;
// };

const isStepCompleted = (obj: Record<string, any>): boolean => {
  // If input is missing, not an object, or empty, return false
  if (!obj || typeof obj !== 'object' || Object.keys(obj).length === 0) {
    return false;
  }

  // .every() returns true only if all keys pass the condition
  return Object.values(obj).every((value) => {
    // 1. Check for null or undefined
    if (value === null || value === undefined) {
      return false;
    }

    // 2. Check for empty strings or strings with only blank spaces
    if (typeof value === 'string') {
      return value.trim() !== '';
    }
    // Numbers (like 0) and booleans (like false) are valid filled inputs
    return true;
  });
};
const hasStepFieldData = (step: any): boolean => {
  if (!Array.isArray(step?.fields)) return false;

  return step.fields.some((field: any) =>
    Object.values(field || {}).some((value: any) => {
      if (value === null || value === undefined) return false;
      if (typeof value === "string") return value.trim() !== "";
      if (typeof value === "boolean") return value;
      if (typeof value === "number") return !Number.isNaN(value);
      if (typeof value === "object") {
        if ("value" in value || "label" in value) {
          return String(value?.value ?? value?.label ?? "").trim() !== "";
        }
        return Object.keys(value).length > 0;
      }
      return true;
    }),
  );
};

const findLastFilledHorizontalStepIndex = (steps: any[]): number => {
  let lastFilledIndex = -1;
  (steps || []).forEach((step: any, index: number) => {
    if (Array.isArray(step?.verticalSteps) && step.verticalSteps.length > 0) {
      lastFilledIndex = index;
    }
  });
  return lastFilledIndex;
};

const resolveAdditionalDetailsResumeVerticalIndex = (step: any, horizontalData?: any): number => {
  const verticalSteps = Array.isArray(step?.verticalSteps) ? step.verticalSteps : [];
  const horizontalStepsData = horizontalData || []

  const loanDetailsFields = horizontalStepsData?.[1].verticalSteps?.find((vStep: any) => normalizeStepName(vStep?.verticalStepName).includes(normalizeStepName("Co-Applicant Details")))?.fields || [];
  const collateralEntry =
    loanDetailsFields?.find((field: any) =>
      Object.keys(field).some((key) =>
        normalizeStepName(key).includes(normalizeStepName("Collateral"))
      )
    ) || null;

  if (!verticalSteps.length) return 0;

  const fundsStep = verticalSteps.find((verticalStep: any) =>
    normalizeStepName(verticalStep?.verticalStepName).includes("fund"),
  );
  const referenceStep = verticalSteps.find((verticalStep: any) =>
    normalizeStepName(verticalStep?.verticalStepName).includes("reference"),
  );
  const collateralStep = verticalSteps.find((verticalStep: any) =>
    normalizeStepName(verticalStep?.verticalStepName).includes("collateral"),
  );

  const hasAnyAdditionalData =
    hasStepFieldData(fundsStep) ||
    hasStepFieldData(referenceStep) ||
    hasStepFieldData(collateralStep) ||
    isStepCompleted(fundsStep) ||
    isStepCompleted(referenceStep) ||
    isStepCompleted(collateralStep);

  const hasBothSubSections = (vStep: any, prefix: string): boolean => {
    if (!Array.isArray(vStep?.fields)) return false;
    const allKeys = vStep.fields.flatMap((f: any) => Object.keys(f || {}));
    const hasSection1 = allKeys.some((k: string) =>
      k.toLowerCase().startsWith(`${prefix}1`) && allKeys.find((k2: string) => k2 === k)
        ? String((vStep.fields.find((f: any) => k in f) || {})[k] || "").trim() !== ""
        : false,
    );
    const hasSection2 = allKeys.some((k: string) =>
      k.toLowerCase().startsWith(`${prefix}2`) && allKeys.find((k2: string) => k2 === k)
        ? String((vStep.fields.find((f: any) => k in f) || {})[k] || "").trim() !== ""
        : false,
    );
    return hasSection1 && hasSection2;
  };

    const legacyCollateralValue = (collateralEntry?.hascollateral ?? "").toString().trim().toLowerCase();
  // "hasCollateral" (inside the Collateral Details step itself) is the current
  // source of truth for whether the applicant has collateral — the old
  // Loan Details "collateral" dropdown read above is only a fallback for
  // applications saved before that field existed.
  const getStepFieldValue = (stepFields: any[] | undefined, fieldNameLower: string): any => {
    if (!Array.isArray(stepFields)) return undefined;
    for (const obj of stepFields) {
      const key = Object.keys(obj || {}).find((k) => k.toLowerCase() === fieldNameLower);
      if (key) return obj[key];
    }
    return undefined;
  };
  const hasCollateralValue = String(
    getStepFieldValue(collateralStep?.fields, "hascollateral") ?? "",
  ).trim().toLowerCase();
  const collateralValue = hasCollateralValue || legacyCollateralValue;

  const referenceFullyFilled =
    isStepCompleted(referenceStep) || hasBothSubSections(referenceStep, "basicreference");
  const collateralFullyFilled =
    // If collateral is "No" or empty, consider it complete
    collateralValue === "no"
      ? true
      : // If collateral is "Yes", validate real collateral fields exist —
        // excluding "hasCollateral" itself, which always matches the
        // "includes collateral" check below but isn't a real collateral field.
        collateralStep?.fields?.some((obj: any) =>
          Object.keys(obj).some((key) =>
            key.toLowerCase() !== "hascollateral" && key.toLowerCase().includes("collateral")
          )
        ) ?? false;
  console.log(collateralFullyFilled,hasCollateralValue,"collateralFullyFilled")
  if (!hasAnyAdditionalData) return 0;
  // If funds step is not completed, land on Fund & Expense page (index 2)
  if (!isStepCompleted(fundsStep)) return 2;
  // If both reference and collateral are fully filled/completed → move to next stage: document & consent (index 4)
  if (referenceFullyFilled && collateralFullyFilled) return 4;
  // Otherwise land on Reference & Collateral page (index 3)
  return 3;
};

const ApplicationCard: React.FC<ApplicationCardProps> = ({
  application,
  finalSteps,
  activeStep,
  isXsOrSm,
  isIphoneSE,
  breData,
  isSliderLoading,
  leadDetailsData,
  sanctionDetailsData,
  provisionalOffer,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [isProvisionalOfferExpanded, setIsProvisionalOfferExpanded] =
    useState(false);
  const [isContinueLoading, setIsContinueLoading] = useState(false);
  const reduxHorizontalSteps = useSelector(
    (state: RootState) => state?.stepper?.horizontalSteps
  );
  const { userProfile } = useSelector(authSelector);
const {
    horizontalSteps
  } = useSelector((state: RootState) => state.stepper);
  const normalizedProvisionalOffer = provisionalOffer?.toString().toLowerCase();
  const partnerStartedJourneyFlag = application?.partnerStartedJourney;

  const parseBooleanFlag = (value: any): boolean => {
    if (typeof value === "boolean") return value;
    if (typeof value === "string") return value.toLowerCase() === "true";
    return false;
  };

  const handleClearData = () => {
    dispatch(setTrackingId(""));
    dispatch(setCollateralId(null));
    dispatch(setreferenceOneId(null));
    dispatch(setreferenceTwoId(null));
    dispatch(setCompletedHorizontalIndex(null));
    dispatch(setActiveHorizontalIndex(0));
    dispatch(setActiveVerticalIndex(0));
    dispatch(clearActiveIndex());
    dispatch(clearFormData());
    dispatch(setLastVerifiedPhoneNumber(""));
    dispatch(setLastVerifiedEmail(""));
    dispatch(setIsDocumentVerified(false));
    dispatch(setIsMobileVerified(false));
    dispatch(setIsEmailVerified(false));
    dispatch(setIsPanVerified(false));
    dispatch(setPanNumber(""));
    dispatch(setAadhaarMandatory(false));
    dispatch(setIsEligibilityCheckSubmitted(false));
    dispatch(setShowAadhaar(false));
    dispatch(setHasPan(""));
    localStorage.removeItem("applicationNo");
    dispatch(clearCoApplicantVerification());
    dispatch(clearIsDocumentVerifiedCoApplicant());
    dispatch(clearAadhaarApplicationNoCoApplicant());
    dispatch(clearAadhaarVerifiedDetailsCoApplicant());
    dispatch(clearAadhaarVerifiedDetails());
    dispatch(setLastPanNumber(""));
    dispatch(setAssignedSMIdValue(""));
    dispatch(setSalesUserId(""));
    dispatch(setCurrentSessionId(""));
    dispatch(setOpenFirstTimeOnlyPopup(null));
    dispatch(clearAllApplicantLoanDetails());
    dispatch(setAadhaarSeedingStatus(null));
    dispatch(setIsEligible(false));
    dispatch(setApplicationSource(""));
    dispatch(clearSavedBasicCoApplicants()) ;
    dispatch(setChatStatusConfig({}));
  };

  const handleUploadDocument = async (submissionId: any) => {
    sessionStorage.setItem("redirectThrough", "view-all");
    try {
      const token: any = process.env.REACT_APP_FETCH_TOKEN;
      const res: any = await fetchUserApplicationsFormData(
        token,
        application.submissionId
      );


      trackCustomerJourneyEvent(
        "VIEWALLAPPLICATIONS_UPLOAD DOCUMENT",
        decrypt(userProfile?.id ?? "") ?? "",
        submissionId,
        {
          label: "VIEWALLAPPLICATIONS_UPLOAD DOCUMENT",
          category: "VIEWALLAPPLICATIONS_UPLOAD DOCUMENT",
          action: "VIEWALLAPPLICATIONS_UPLOAD DOCUMENT",
          page: "View All Applications_Upload Document",
        }
      );

      const apps = res.data?.applications || [];
      const courceCate = apps
        ?.flatMap((app: any) => app.horizontalSteps || [])
        ?.flatMap((h: any) => h.verticalSteps || [])
        ?.flatMap((v: any) => v.fields || [])
        ?.find((f: any) => f.courseCategory)
        ?.courseCategory;
      if (!courceCate) {
        dispatch(
          setStatusPopup({
            status: "info",
            message: "Please Select Course Category ! It is mandatory field.",
          })
        );
        return;
      } else {
        let apiFormData: any = {};
        for (let i = 0; i < apps?.[0]?.horizontalSteps?.length; i++) {
          const verticalSteps = apps?.[0]?.horizontalSteps?.[i]?.verticalSteps;
          for (let j = 0; j < verticalSteps?.length; j++) {
            const fields = verticalSteps?.[j]?.fields;
            for (let k = 0; k < fields?.length; k++) {
              const field = fields?.[k];
              apiFormData = { ...apiFormData, ...field };
            }
          }
        }

        dispatch(updateFormData(apiFormData));
        dispatch(setTrackingId(submissionId));
        dispatch(setCollateralId(application.collateralId || null));
        dispatch(setreferenceOneId(application.referenceOneId || null));
        dispatch(setreferenceTwoId(application.referenceTwoId || null));
        dispatch(setCoApplicantDetails(submissionId));
        navigate("/application/upload-document");
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleInvokeLeadApiData = (apps: any) => {
    dispatch(setTrackingId(apps?.submissionId));
    dispatch(setCollateralId(apps?.collateralId || null));
    dispatch(setreferenceOneId(apps?.referenceOneId || null));
    dispatch(setreferenceTwoId(apps?.referenceTwoId || null));
    dispatch(setreferenceOneId(apps?.referenceOneId || null));
    dispatch(setreferenceTwoId(apps?.referenceTwoId || null));
    dispatch(setApplicationId(apps?.applicationId));
    dispatch(setApplicantId(apps?.applicantId));
    dispatch(setLeadSequenceId(apps?.leadId));
    dispatch(setAssignedSMIdValue(apps?.assignedSMId));
    dispatch(
      setCheckIsLeadApiInvoked({
        key: "ASSIGN_SM",
        value: apps?.assignedSMId ? true : false,
      })
    );
    dispatch(
      setCheckIsLeadApiInvoked({
        key: "CREATE_LEAD",
         value: apps?.leadId ? true : false,
      })
    );
    dispatch(
      setCheckIsLeadApiInvoked({
        key: "LEAD_TO_APPLICATION",
        value:
          apps?.applicantId &&
          apps?.applicationId &&
          apps?.applicationDisplayCode
            ? true
            : false,
      })
    );
  };

  const extractCoApplicantKeys = (fields: any[]) => {
    const coApplicantSet = new Set<string>();

    fields.forEach((field) => {
      const match = field.name?.match(/CoApplicant(\d+)/);
      if (match?.[1]) {
        coApplicantSet.add(`CoApplicant${match[1]}`);
      }
    });

    return Array.from(coApplicantSet); // ["CoApplicant1", "CoApplicant2"]
  };

  // Extract co-applicant keys from fetched form data objects (without name property)
  const extractCoApplicantKeysFromData = (fieldObjects: any[]) => {
    const coApplicantSet = new Set<string>();
    fieldObjects?.forEach((obj: any) => {
      Object.keys(obj || {}).forEach((key) => {
        const match = key.match(/CoApplicant(\d+)/);
        if (match?.[1]) {
          coApplicantSet.add(`CoApplicant${match[1]}`);
        }
      });
    });
    return Array.from(coApplicantSet);
  };

  
  const handleContinue = async (selectedApp: any) => {
    dispatch(setHasCheckedInitialSummary(false));
    // Clear any Documents/Consent tab choice persisted from a previous visit to the
    // Additional Summary step, so re-entering fresh via Continue always starts on
    // Documents instead of restoring a stale choice.
    if (selectedApp?.submissionId) {
      localStorage.removeItem(`additionalSummaryActiveTab:${selectedApp.submissionId}`);
    }
    if (selectedApp?.assistedJourneyRequired) {
      dispatch(
        setStatusPopup({
          status: "info",
          message:
            "You have already started your journey with a partner. Please complete your journey with the partner.",
        })
      );
      return;
    } else {
      setIsContinueLoading(true);
      try {
        dispatch(setIsEligibilityCheckSubmitted(false));
        handleClearData();

        const breObj = breData?.[selectedApp?.submissionId];
        // Consider blank if all values are empty string, null, or undefined
        const isBlankObject =
          breObj &&
          Object.keys(breObj).length > 0 &&
          Object.values(breObj).every(
            (v) => v === "" || v === null || v === undefined
          );

        if (isBlankObject) {
          dispatch(setBreStatus("FROM_FORM"));
        } else {
          dispatch(setBreStatus("FROM_APPLICATION"));
        }
        try {
          const token: any = process.env.REACT_APP_FETCH_TOKEN;
          const applicationId = selectedApp?.submissionId;
         (dispatch as any)(getFormJson({ product: "SLI", trackingId: applicationId }));
          const res: any = await fetchUserApplicationsFormData(
            token,
            applicationId
          );
          const apps = res.data?.applications || [];

          // Sync the freshly-fetched application into fetchUserApplicationData so
          // isDIYJourney (partnerStartedJourney-derived) reflects THIS application
          // instead of whatever was left over from a previously viewed one.
          if (apps?.[0]) {
            dispatch(setFetchUserApplicationData(apps[0]));
          }

          dispatch(setLeadSequenceId(apps?.[0]?.leadId || ""));
          const applicationSource = apps?.[0]?.source || "";

          trackCustomerJourneyEvent(
            `${getGAExistingApplicationStatements(applicationSource)}_VIEWALLAPPLICATIONS_CONTINUE`,
            decrypt(userProfile?.id ?? "") ?? "",
            selectedApp?.submissionId,
            {
              label: `${getGAExistingApplicationStatements(applicationSource)}_VIEWALLAPPLICATIONS_CONTINUE`,
              category: `${getGAExistingApplicationStatements(applicationSource)}_VIEWALLAPPLICATIONS_CONTINUE`,
              action: `${getGAExistingApplicationStatements(applicationSource)}_VIEWALLAPPLICATIONS_CONTINUE`,
              page: "View All Applications Continue",
            }
          );

          const verticalSteps = apps?.[0]?.horizontalSteps?.[0]?.verticalSteps;
          const filterCourseData = Array.isArray(verticalSteps)
            ? verticalSteps.find((elem: any) => elem?.verticalStepName === "Provide Course Details")
            : undefined;

          if (filterCourseData) {
            // Sync notInList to Redux from fetched course-details (universityNotInList, instituteNotInList, courseNameNotInList)
            // Sync notInList to Redux from fetched course-details (universityNotInList, instituteNotInList, courseNameNotInList)
            const fields = filterCourseData?.fields || [];
            const getFieldValue = (key: string) => {
              const obj = fields.find((f: any) => f && key in f);
              return obj ? String(obj[key]).toLowerCase() : "";
            };
            dispatch(clearNotInList());
            if (getFieldValue("universityNotInList") === "true") dispatch(setNotInList("University Name"));
            if (getFieldValue("instituteNotInList") === "true") dispatch(setNotInList("Institute Name"));
            if (getFieldValue("courseNameNotInList") === "true") dispatch(setNotInList("Course Name"));
          }

          // Prefer fetched application data to drive first-time correctness
          const fetchedApplicantLoanStep = apps?.[0]?.horizontalSteps?.find(
            (step: any) =>
              step.horizontalStepName === "Applicant & Loan Details"
          );

          const fetchedLoanDetailsStep = fetchedApplicantLoanStep?.verticalSteps?.find(
            (vStep: any) => vStep.verticalStepName === "Co-Applicant Details"
          );

          if (fetchedLoanDetailsStep?.fields) {
            // 1) Mark co-applicant basics as saved based on fetched data
            const coApplicantKeysFromData = extractCoApplicantKeysFromData(
              fetchedLoanDetailsStep.fields || [],
            );
            coApplicantKeysFromData.forEach((coAppKey) => {
              dispatch(
                setSavedBasicForCoApplicant({
                  coAppKey,
                  value: true,
                }),
              );
            });

            // 2) Build fetched isEmployed keys set
            const fetchedIsEmployedFields = new Set<string>();
            fetchedLoanDetailsStep.fields.forEach((field: any) => {
              Object.keys(field || {}).forEach((key) => {
                if (
                  /^employmentCoApplicant\d+isEmployed$/.test(key) &&
                  field[key] &&
                  field[key] !== ""
                ) {
                  fetchedIsEmployedFields.add(key);
                }
              });
            });

            // 3) If Redux schema is available, compare and potentially disable add more
            if (reduxHorizontalSteps && Array.isArray(reduxHorizontalSteps)) {
              const reduxApplicantLoanStep = reduxHorizontalSteps.find(
                (step: any) => step.stepLabel === "Applicant & Loan Details",
              );
              const reduxLoanDetailsStep =
                reduxApplicantLoanStep?.verticalSteps?.find(
                  (vStep: any) => vStep.stepLabel === "Co-Applicant Details",
                );
              const reduxIsEmployedFields = (reduxLoanDetailsStep?.fields || [])
                .map((field: any) => field.name)
                .filter((name: string) =>
                  /^employmentCoApplicant\d+isEmployed$/.test(name),
                );

              if (reduxIsEmployedFields.length > 0) {
                const missingFields = reduxIsEmployedFields.filter(
                  (fieldName: string) =>
                    !fetchedIsEmployedFields.has(fieldName),
                );
                if (missingFields.length > 0) {
                  dispatch(setDisableAddMoreCoApplicant(true));
                }
              }
            }
          }

          dispatch(setApplicationSource(apps?.[0]?.source || ""));

          handleInvokeLeadApiData(apps?.[0]);
          dispatch(setAadhaarSeedingStatus(apps?.[0]?.isAadhaarSeeded));

          // const courceCate =
          //   apps?.[0]?.horizontalSteps?.[0]?.verticalSteps?.[1]?.fields?.[0]
          //     ?.courseCategory;

          // if (!courceCate) {
          //   dispatch(
          //     setStatusPopup({
          //       status: "info",
          //       message:
          //         "Please Select Cource Category ! It is mandatory field.",
          //     })
          //   );
          //   return;
          // }

          // setting firsttime view only popup flags which will get displayed in summary page
          dispatch(
            setOpenFirstTimeOnlyPopup({
              isSanctionedPopupViewed: apps[0]?.SanctionedPopUp,
              isDisbursedPopupViewed: apps[0]?.DisbursementPopUp,
              isConnectWithSalesPopupViewed: apps[0]?.ConnectWithSalesPopUp,
            })
          );

          // setting assigned sales person id, which is application specific, will be used for display validation of Connect button and Chat
          dispatch(setSalesUserId(res?.data?.applications?.[0]?.assignedSMId));

          // store customerConsentTime from fetched application
          dispatch(setCustomerConsentTime(apps?.[0]?.customerConsentTime!=null ? true : false));

          // Clear display horizontal steps before setting new data
          dispatch(setDisplayHorizontalSteps([]));
          
          // Add small delay to ensure clearing is processed before setting new data
          await new Promise(resolve => setTimeout(resolve, 50));
          
          // this logic is for getting customized array of horizontalsteps
          let finalSteps: any[] = [];
          for (let i = 0; i < apps.length; i++) {
            const element = apps[i];
            //finalSteps = getCombinedApplicationSteps(element);
          }
          //dispatch(setDisplayHorizontalSteps(finalSteps));

        const data = filterCourseData?.fields?.find((f: any) => f.admissionStatus?.toLowerCase() === "undecided");
        const country = filterCourseData?.fields?.find((f: any) => f.country)?.country;
        const universityCountryId = filterCourseData?.fields?.find((f: any) => f.universityCountryId)?.universityCountryId;
        const isValid = checkUndecided(country, universityCountryId, applicationSource, apps?.[0]?.isQualified, apps[0]?.horizontalSteps?.[1]?.verticalSteps[0]?.fields?.length);
          if (data && isValid) {
              dispatch(setActiveHorizontalIndex(0));
              dispatch(setActiveVerticalIndex(1));
        } else {

          if (
            apps?.[0] &&
            apps?.[0]?.isQualified === true &&
            apps?.[0]?.horizontalSteps?.[0]?.verticalSteps?.length === 3 &&
            apps?.[0]?.horizontalSteps?.[1].completionRate != 100 // if first two steps are 100% completed it means User shouldnt navigate to forms
          ) {
            const findVerticalStepLength = apps?.[0]?.horizontalSteps?.[1]?.verticalSteps?.length === 0 ? 0 :
              apps?.[0]?.horizontalSteps?.[1]?.verticalSteps?.length - 1;
            const qualifiedHorizontalStepsData = apps?.[0]?.horizontalSteps || [];
            const qualifiedLastFilledIndex = findLastFilledHorizontalStepIndex(qualifiedHorizontalStepsData);
            const qualifiedAdditionalDetailsIndex = qualifiedHorizontalStepsData.findIndex(
              (step: any) =>
                normalizeStepName(step?.horizontalStepName) ===
                normalizeStepName("Additional Details & Documents"),
            );
            const data = qualifiedHorizontalStepsData.find(
                (step: any) =>
                  normalizeStepName(step?.horizontalStepName) ===
                  normalizeStepName("Additional Details & Documents"),
              );
            if(horizontalSteps[0]?.verticalSteps[1]?.fields?.length>apps?.[0]?.horizontalSteps?.[0]?.verticalSteps?.[1]?.fields?.length){
                dispatch(
                  setActiveVerticalIndex(
                    apps?.[0]?.horizontalSteps?.[0]?.verticalSteps?.length-2
                  )
                );
                 dispatch(
                setActiveHorizontalIndex(0)
              );
            }else if (qualifiedLastFilledIndex === qualifiedAdditionalDetailsIndex) {
              dispatch(setActiveHorizontalIndex(qualifiedAdditionalDetailsIndex));
              if(findApplicantStep(data)===true &&  (data?.verticalSteps?.length===1 ||  data?.verticalSteps?.length===2)){
                dispatch(
                  setActiveVerticalIndex(1),
                )
              }else{
                const totalRefNo = await getReferenceData(apps?.[0]?.submissionId)
                if(totalRefNo===1){
                  dispatch(
                    setActiveVerticalIndex(3),
                  )
                }else{
                  dispatch(
                    setActiveVerticalIndex(
                      resolveAdditionalDetailsResumeVerticalIndex(
                        qualifiedHorizontalStepsData?.[qualifiedAdditionalDetailsIndex],
                        qualifiedHorizontalStepsData
                      ),
                    ),
                  );
                }
              }
            } 
            else{
               const horizontalStepsData = apps?.[0]?.horizontalSteps || [];
            const lastFilledHorizontalIndex = findLastFilledHorizontalStepIndex(
              horizontalStepsData,
            );
            const additionalDetailsIndex = horizontalStepsData.findIndex(
              (step: any) =>
                normalizeStepName(step?.horizontalStepName) ===
                normalizeStepName("Additional Details & Documents"),
            );
            const filledHorizontalSteps = horizontalStepsData.filter(
              (elem: any) => elem?.verticalSteps?.length > 0,
            );
            const findActiveHorizontalIndex =
              apps?.[0]?.horizontalSteps?.filter(
                (elem: any) => elem?.verticalSteps?.length > 0
              );
               if(apps?.[0]?.horizontalSteps?.[1]?.verticalSteps?.length===2 && apps?.[0]?.horizontalSteps?.[1]?.verticalSteps
                  ?.find((step:any) => step?.verticalStepName === "Co-Applicant Details") && apps?.[0]?.horizontalSteps?.[1]?.verticalSteps
                  ?.find((step:any) => step?.verticalStepName === "Student Details")?.fields?.length === 4){
                    dispatch(setActiveHorizontalIndex(1));
                    dispatch(setActiveVerticalIndex(0));
    
              }else if (lastFilledHorizontalIndex === additionalDetailsIndex) {
                dispatch(setActiveHorizontalIndex(additionalDetailsIndex));
                dispatch(
                  setActiveVerticalIndex(
                    resolveAdditionalDetailsResumeVerticalIndex(
                      horizontalStepsData?.[additionalDetailsIndex],
                      horizontalStepsData
                    ),
                  ),
                );
              }
              else if (
                additionalDetailsIndex !== -1 &&
                lastFilledHorizontalIndex > additionalDetailsIndex
              ) {
                // Application already progressed past Additional Details &
                // Documents (e.g. Summary/Loan Summary was already reached) —
                // resume at its last real step (Document & Consent) instead of
                // falling through to the stepper-index heuristics below, which
                // assume no step after Additional Details ever has data.
                dispatch(setActiveHorizontalIndex(additionalDetailsIndex));
                dispatch(setActiveVerticalIndex(4));
              }
              else if (apps?.[0]?.horizontalSteps?.[
                    findActiveHorizontalIndex.length - 1
                ]?.verticalSteps?.length <=  6 && apps?.[0]?.isProvisionalGenerated===true) {
                  
                  dispatch(setActiveHorizontalIndex(3));
                  dispatch(setActiveVerticalIndex(0));
                }
              else if (
                findActiveHorizontalIndex.length - 1 == 1 &&
                apps?.[0]?.horizontalSteps?.[findActiveHorizontalIndex.length - 1]
                  ?.verticalSteps?.length == 6
              ) {
                // Find the 'Loan Details' vertical step
                const loanDetailsStep = apps?.[0]?.horizontalSteps?.[
                  findActiveHorizontalIndex.length - 1
                ]?.verticalSteps?.find(
                  (step: any) => step.verticalStepName === "Co-Applicant Details"
                );
                // Check for LoanDetailsLoanAmount and collateral fields with values
                const hasLoanDetails =
                  loanDetailsStep &&
                  Array.isArray(loanDetailsStep.fields) &&
                  loanDetailsStep.fields.some(
                    (f: any) =>
                      f.LoanDetailsLoanAmount && f.LoanDetailsLoanAmount !== ""
                  ) &&
                  loanDetailsStep.fields.some(
                    (f: any) => f.collateral && f.collateral !== ""
                  );

                if (hasLoanDetails) {
                  // Dynamically check for any field key that includes 'basic', 'address', or 'employment'
                  const fieldKeyPatterns = ["basic", "address", "employment"];
                  const hasOtherFields = fieldKeyPatterns.every((pattern) =>
                    loanDetailsStep.fields.some((f: any) =>
                      Object.keys(f).some(
                        (key) =>
                          key.toLowerCase().includes(pattern) &&
                          f[key] &&
                          f[key] !== ""
                      )
                    )
                  );

                  if (!isBlankObject && hasOtherFields) {
                    dispatch(setActiveHorizontalIndex(3));
                    dispatch(setActiveVerticalIndex(0));
                  } else {
                    dispatch(setActiveHorizontalIndex(2));
                    dispatch(setActiveVerticalIndex(0));
                  }
                } else {
                  dispatch(
                    setActiveHorizontalIndex(findActiveHorizontalIndex.length - 1)
                  );
                  dispatch(setActiveVerticalIndex(5));
                }
              }
              else{
                 if(apps?.[0]?.isProvisionalGenerated===true){
                  dispatch(setActiveHorizontalIndex(qualifiedLastFilledIndex));
                  dispatch(
                    setActiveVerticalIndex(
                     resolveAdditionalDetailsResumeVerticalIndex(
                      qualifiedHorizontalStepsData?.[qualifiedAdditionalDetailsIndex],
                      qualifiedHorizontalStepsData
                    ),
                    ),
                  );
                }else{
                  dispatch(setActiveHorizontalIndex(1));
                  dispatch(setActiveVerticalIndex(findVerticalStepLength));
                }
              }
            }
          } else {
            const horizontalStepsData = apps?.[0]?.horizontalSteps || [];
              const lastFilledHorizontalIndex = findLastFilledHorizontalStepIndex(
                horizontalStepsData,
              );
              const additionalDetailsIndex = horizontalStepsData.findIndex(
                (step: any) =>
                  normalizeStepName(step?.horizontalStepName) ===
                  normalizeStepName("Additional Details & Documents"),
              );
              const filledHorizontalSteps = horizontalStepsData.filter(
                (elem: any) => elem?.verticalSteps?.length > 0,
              );
            dispatch(setTrackingId(apps?.[0]?.submissionId || ""));
            const findActiveHorizontalIndex =
              apps?.[0]?.horizontalSteps?.filter(
                (elem: any) => elem?.verticalSteps?.length > 0
              );
              
              const data = horizontalStepsData.find(
                (step: any) =>
                  normalizeStepName(step?.horizontalStepName) ===
                  normalizeStepName("Additional Details & Documents"),
              );
              if(horizontalSteps[0]?.verticalSteps[1]?.fields?.length>apps?.[0]?.horizontalSteps?.[0]?.verticalSteps?.[1]?.fields?.length){
                dispatch(
                  setActiveVerticalIndex(
                    apps?.[0]?.horizontalSteps?.[0]?.verticalSteps?.length-2
                  )
                );
                 dispatch(
                setActiveHorizontalIndex(0)
              );
            }
            else if (lastFilledHorizontalIndex === additionalDetailsIndex) {
              dispatch(setActiveHorizontalIndex(additionalDetailsIndex));
              if(findApplicantStep(data)===true  && (data?.verticalSteps?.length===1 || data?.verticalSteps?.length===2)){
                dispatch(
                  setActiveVerticalIndex(1),
                )
              }else{
                const totalRefNo = await getReferenceData(apps?.[0]?.submissionId)
                if(totalRefNo===1){
                  dispatch(
                    setActiveVerticalIndex(3),
                  )
                }else{
                  dispatch(
                    setActiveVerticalIndex(
                      resolveAdditionalDetailsResumeVerticalIndex(
                        horizontalStepsData?.[additionalDetailsIndex],
                        horizontalStepsData
                      ),
                    ),
                  );
                }

              }
              
            }
            else if (
              additionalDetailsIndex !== -1 &&
              lastFilledHorizontalIndex > additionalDetailsIndex
            ) {
              // Application already progressed past Additional Details &
              // Documents (e.g. Summary/Loan Summary was already reached) —
              // resume at its last real step (Document & Consent) instead of
              // falling through to the stepper-index heuristics below, which
              // assume no step after Additional Details ever has data.
              dispatch(setActiveHorizontalIndex(additionalDetailsIndex));
              dispatch(setActiveVerticalIndex(4));
            }
            else if (
              findActiveHorizontalIndex.length - 1 == 1 &&
              apps?.[0]?.horizontalSteps?.[findActiveHorizontalIndex.length - 1]
                ?.verticalSteps?.length == 6
            ) {
              // Find the 'Loan Details' vertical step
              const loanDetailsStep = apps?.[0]?.horizontalSteps?.[
                findActiveHorizontalIndex.length - 1
              ]?.verticalSteps?.find(
                (step: any) => step.verticalStepName === "Co-Applicant Details"
              );
              // Check for LoanDetailsLoanAmount and collateral fields with values
              const hasLoanDetails =
                loanDetailsStep &&
                Array.isArray(loanDetailsStep.fields) &&
                loanDetailsStep.fields.some(
                  (f: any) =>
                    f.LoanDetailsLoanAmount && f.LoanDetailsLoanAmount !== ""
                ) &&
                loanDetailsStep.fields.some(
                  (f: any) => f.collateral && f.collateral !== ""
                );

              if (hasLoanDetails) {
                // Dynamically check for any field key that includes 'basic', 'address', or 'employment'
                const fieldKeyPatterns = ["basic", "address", "employment"];
                const hasOtherFields = fieldKeyPatterns.every((pattern) =>
                  loanDetailsStep.fields.some((f: any) =>
                    Object.keys(f).some(
                      (key) =>
                        key.toLowerCase().includes(pattern) &&
                        f[key] &&
                        f[key] !== ""
                    )
                  )
                );

                if (!isBlankObject && hasOtherFields) {
                  dispatch(setActiveHorizontalIndex(3));
                  dispatch(setActiveVerticalIndex(0));
                } else {
                  dispatch(setActiveHorizontalIndex(2));
                  dispatch(setActiveVerticalIndex(0));
                }
              } else {
                dispatch(
                  setActiveHorizontalIndex(findActiveHorizontalIndex.length - 1)
                );
                dispatch(setActiveVerticalIndex(5));
              }
            } else {
              dispatch(
                setActiveHorizontalIndex(findActiveHorizontalIndex.length - 1)
              );
              if (findActiveHorizontalIndex.length === 1) {
                dispatch(
                  setActiveVerticalIndex(
                    apps?.[0]?.horizontalSteps?.[
                      findActiveHorizontalIndex.length - 1
                    ]?.verticalSteps?.length
                  )
                );

              } else {
                let filterveritical=apps?.[0]?.horizontalSteps?.[
                      findActiveHorizontalIndex.length - 1
                    ]?.verticalSteps?.find(
                        (step: any) => step?.verticalStepName ==="Co-Applicant Details"
                      );
                  const count = apps?.[0]?.horizontalSteps?.[1]?.verticalSteps[0]?.fields?.filter((item: any) => {
                  const value = Object.values(item)[0];
                  return value !== "" && value !== null && value !== undefined;
                  }).length;
                  // const isSingleVerticalStep = apps?.[0]?.horizontalSteps?.[1]?.verticalSteps?.length === 1;
                  const minimumCount =  13;

                  if (count < minimumCount)  {
                        dispatch(
                          setActiveVerticalIndex(0)
                        );
                  }else if (apps?.[0]?.horizontalSteps?.[
                  findActiveHorizontalIndex.length - 1
                    ]?.verticalSteps?.length <= 6 && apps?.[0]?.isProvisionalGenerated===true) {
                     
                        dispatch(setActiveHorizontalIndex(3));
                        dispatch(setActiveVerticalIndex(0));
                     

                    }
                   else if(apps?.[0]?.horizontalSteps?.[
                      findActiveHorizontalIndex.length - 1
                    ]?.verticalSteps?.length!=6 && filterveritical?.verticalStepName === "Co-Applicant Details"){
                      dispatch(
                        setActiveVerticalIndex(
                          apps?.[0]?.horizontalSteps?.[
                            findActiveHorizontalIndex.length - 1
                          ]?.verticalSteps?.length - 1
                        )
                      );
                    } else{
                      dispatch(
                        setActiveVerticalIndex(
                          apps?.[0]?.horizontalSteps?.[
                            findActiveHorizontalIndex.length - 1
                          ]?.verticalSteps?.length
                        )
                      );

                    }
                
              }
            }
            dispatch(
              setCompletedHorizontalIndex(findActiveHorizontalIndex.length - 1)
            );
          }
        }

          const lengthOfHorizontalSteps = apps?.[0]?.horizontalSteps?.length;
          let apiFormData: any = {};
          for (let i = 0; i < lengthOfHorizontalSteps; i++) {
            const verticalSteps =
              apps?.[0]?.horizontalSteps?.[i]?.verticalSteps;
            for (let j = 0; j < verticalSteps?.length; j++) {
              const fields = verticalSteps?.[j]?.fields;
              for (let k = 0; k < fields?.length; k++) {
                const field = fields?.[k];
                apiFormData = { ...apiFormData, ...field };
              }
            }
          }
          dispatch(setIsPanVerified(Boolean(apiFormData?.isPanVerified)));
          if (lengthOfHorizontalSteps >= 2) {
            dispatch(setIsEligibilityCheckSubmitted(true));
          }
          dispatch(setLastVerifiedPhoneNumber(apiFormData?.phone_number));
          dispatch(setLastVerifiedEmail(apiFormData?.email));
          dispatch(
            setIsMobileVerified(apiFormData?.phone_number ? true : false)
          );
          dispatch(setIsEmailVerified(apiFormData?.email ? true : false));
          dispatch(updateFormData(apiFormData));
          /**
           * Iterates over all fields in the fetched application form data.
           * For each co-applicant PAN, email, and phone field:
           *    - Extracts the co-applicant index and field type using regex.
           *    - Builds a verification object indicating whether each field is verified and stores the last verified value.
           *    - Dispatches the verification status to Redux for each co-applicant.
           * This ensures the UI can correctly display "Verified" status for each co-applicant's PAN, email, and phone fields.
           */
          Object.entries(apiFormData).forEach(([key, value]) => {
            const match = key.match(
              /^coApplicant(\d+)(PanNumber|Email|Phone_number)$/
            );
            if (match) {
              const idx = Number(match[1]) - 1; // usually index starts from 0
              const type = match[2];
              let verification: any = {};
              if (type === "PanNumber") {
                verification.panVerified = !!value;
                verification.lastPanNumber = value;
              }
              if (type === "Email") {
                verification.emailVerified = !!value;
                verification.lastVerifiedEmail = value;
              }
              if (type === "Phone_number") {
                verification.mobileVerified = !!value;
                verification.lastVerifiedMobileNumber = value;
              }
              dispatch(
                setCoApplicantVerification({
                  index: String(idx),
                  data: verification,
                })
              );
            }
          });
          // Call checkOffer API if isQualified is false
          if (apps?.[0] && apps?.[0]?.isQualified === false && apps?.[0]?.horizontalSteps[0]?.verticalSteps.length === 3 && apps?.[0]?.horizontalSteps[1]?.verticalSteps.length === 0) {
            try {
              const payload = {
                applicationId: apps?.[0]?.submissionId,
                name: "getCustomerEligibility",
              };

              const res: any = await eligibilityCheckServices.fetchBreApi(payload);
              if (res?.data?.data?.Scheme_Available !== "Yes" && res?.data?.data?.Scheme_Available !== "No" ) {
                const brePayload = {
                  applicationId: apps?.[0]?.submissionId,
                  provisionalOfferBody: {
                    values: {
                      input: {
                        Unique_Lead_ID: apps?.[0]?.submissionId,
                        oApplicant: {
                          oApplName: {
                            sFirstName: apiFormData?.firstName || "",
                            sLastName: apiFormData?.lastName || "",
                          },
                          aCourseDetails: [
                            {
                              ...(apiFormData?.instituteNotInList === "false" && {
                                institute_code: apiFormData?.institute_code || "",
                              }),
                              ...(apiFormData?.courseNameNotInList === "false" && {
                                course_code: apiFormData?.courseCode || "",
                              }),
                              ...(apiFormData?.universityNotInList === "false" && {
                                university_campus_id:
                                  apiFormData?.universityCampusId || "",
                              }),
                              category: apiFormData?.courseType || "",
                              admission_status:
                                apiFormData?.admissionStatus || "",
                              course_category: apiFormData?.courseCategory || "",
                            },
                          ],
                        },
                      },
                    },
                  },
                };

                const breResp = await eligibilityCheckServices.checkOffer(
                  brePayload
                );
              }
              //dispatch(setBreData(breResp?.data?.data));
            } catch (error) {
              console.error("CheckOffer API call failed:", error);
              dispatch(setIsEligible(false));
            }
          }
          dispatch(
            setIsMobileVerified(parseBooleanFlag(apiFormData?.isMobileVerified)),
          );
          dispatch(setIsEmailVerified(parseBooleanFlag(apiFormData?.isEmailVerified)));
          const isLoanOverview = await gotoPageStepOrLoanOverviewPage(selectedApp?.submissionId);
          const additionalStep=apps?.[0]?.horizontalSteps?.find((step:any) =>
            /Additional\s*(Details|Document)/i.test(step.horizontalStepName || "")
          );
          const checkAllFilled = additionalStep.verticalSteps?.find((vStep:any) =>
            /Reference.*Details/i.test(vStep.verticalStepName || "")
          );
          const collateral = additionalStep.verticalSteps?.find((vStep:any) =>
            /Collateral.*Details/i.test(vStep.verticalStepName || "")
          );
          if(isLoanOverview && checkAllFilled?.verticalStepName==="Reference Details" && collateral?.verticalStepName==="Collateral Details"){
            navigate("/application/loan-summary");
          } else {
            navigate("/application/apply-now");
          }
          // navigate("/application/apply-now");
        } catch (e) {
          console.log(e);
        }
      } catch (e) {
        console.log(e);
      } finally {
        setIsContinueLoading(false);
      }
    }

    // navigate("/stepper")
  };

  // --------- please make sure you are adding similar changes to function inside of ExistingApplication.tsx file
  const handleViewSummary = async () => {
    dispatch(setIsEligibilityCheckSubmitted(false));
    dispatch(setDocumentApplicantType(""));
    handleClearData();

    dispatch(setBreStatus("FROM_APPLICATION"));

    trackCustomerJourneyEvent(
      "VIEWALLAPPLICATIONS_VIEWSUMMARY",
      decrypt(userProfile?.id ?? "") ?? "",
      application?.submissionId,
      {
        label: "VIEWALLAPPLICATIONS_VIEWSUMMARY",
        category: "VIEWALLAPPLICATIONS_VIEWSUMMARY",
        action: "VIEWALLAPPLICATIONS_VIEWSUMMARY",
        page: "View All Applications_View Summary",
      }
    );

    try {
      const token: any = process.env.REACT_APP_FETCH_TOKEN;
      const applicationId = application?.submissionId;
      const res: any = await fetchUserApplicationsFormData(
        token,
        applicationId
      );
      const apps = res.data?.applications || [];
      let count = 0;



      const verticalStepsSummary = apps?.[0]?.horizontalSteps?.[0]?.verticalSteps;
      const filterCourseDataSummary = Array.isArray(verticalStepsSummary)
        ? verticalStepsSummary.find((elem: any) => elem?.verticalStepName === "Provide Course Details")
        : undefined;

      if (filterCourseDataSummary) {
        const fields = filterCourseDataSummary?.fields || [];
        const getFieldValue = (key: string) => {
          const obj = fields.find((f: any) => f && key in f);
          return obj ? String(obj[key]).toLowerCase() : "";
        };
        dispatch(clearNotInList());
        if (getFieldValue("universityNotInList") === "true") dispatch(setNotInList("University Name"));
        if (getFieldValue("instituteNotInList") === "true") dispatch(setNotInList("Institute Name"));
        if (getFieldValue("courseNameNotInList") === "true") dispatch(setNotInList("Course Name"));
      }

      const courceCate = apps
        ?.flatMap((app: any) => app.horizontalSteps || [])
        ?.flatMap((h: any) => h.verticalSteps || [])
        ?.flatMap((v: any) => v.fields || [])
        ?.find((f: any) => f.courseCategory)
        ?.courseCategory;
      if (!courceCate) {
        dispatch(
          setStatusPopup({
            status: "info",
            message: "Please Select Course Category ! It is mandatory field.",
          })
        );
        return;
      }

      // setting firsttime view only popup flags which will get displayed in summary page
      dispatch(
        setOpenFirstTimeOnlyPopup({
          isSanctionedPopupViewed: apps[0]?.SanctionedPopUp,
          isDisbursedPopupViewed: apps[0]?.DisbursementPopUp,
          isConnectWithSalesPopupViewed: apps[0]?.ConnectWithSalesPopUp,
        })
      );

      // setting assigned sales person id, which is application specific, will be used for display validation of Connect button and Chat
      dispatch(setSalesUserId(res?.data?.applications?.[0]?.assignedSMId));

      // this logic is for getting customized array of horizontalsteps
      let finalSteps: any[] = [];
      for (let i = 0; i < apps.length; i++) {
        const element = apps[i];
        //finalSteps = getCombinedApplicationSteps(element);
        //count = finalSteps.filter((val) => val.status === "completed").length;
      }
      //dispatch(setDisplayHorizontalSteps(finalSteps));

      dispatch(setTrackingId(apps?.[0]?.submissionId || ""));
      dispatch(setCollateralId(apps?.[0]?.collateralId || null));
      dispatch(setreferenceOneId(apps?.[0]?.referenceOneId || null));
      dispatch(setreferenceTwoId(apps?.[0]?.referenceTwoId || null));
      const lengthOfHorizontalSteps = apps?.[0]?.horizontalSteps?.length;
      dispatch(setActiveHorizontalIndex(lengthOfHorizontalSteps - 1));
      dispatch(
        setActiveVerticalIndex(
          apps?.[0]?.horizontalSteps?.[lengthOfHorizontalSteps - 1]
            ?.verticalSteps?.length
        )
      );

      let apiFormData: any = {};

      for (let i = 0; i < lengthOfHorizontalSteps; i++) {
        const verticalSteps = apps?.[0]?.horizontalSteps?.[i]?.verticalSteps;
        for (let j = 0; j < verticalSteps?.length; j++) {
          const fields = verticalSteps?.[j]?.fields;
          for (let k = 0; k < fields?.length; k++) {
            const field = fields?.[k];
            apiFormData = { ...apiFormData, ...field };
          }
        }
      }

      dispatch(setLastVerifiedPhoneNumber(apiFormData?.phone_number));
      dispatch(setLastVerifiedEmail(apiFormData?.email));
      dispatch(setIsMobileVerified(apiFormData?.phone_number ? true : false));
      dispatch(setIsEmailVerified(apiFormData?.email ? true : false));
      dispatch(updateFormData(apiFormData));

      // /**
      //  * Iterates over all fields in the fetched application form data.
      //  * For each co-applicant PAN, email, and phone field:
      //  *   - Extracts the co-applicant index and field type using regex.
      //  *   - Builds a verification object indicating whether each field is verified and stores the last verified value.
      //  *   - Dispatches the verification status to Redux for each co-applicant.
      //  * This ensures the UI can correctly display "Verified" status for each co-applicant's PAN, email, and phone fields.
      //  */
      Object.entries(apiFormData).forEach(([key, value]) => {
        const match = key.match(
          /^coApplicant(\d+)(PanNumber|Email|Phone_number)$/
        );
        if (match) {
          const idx = Number(match[1]) - 1; // usually index starts from 0
          const type = match[2];
          let verification: any = {};
          if (type === "PanNumber") {
            verification.panVerified = !!value;
            verification.lastPanNumber = value;
          }
          if (type === "Email") {
            verification.emailVerified = !!value;
            verification.lastVerifiedEmail = value;
          }
          if (type === "Phone_number") {
            verification.mobileVerified = !!value;
            verification.lastVerifiedMobileNumber = value;
          }
          dispatch(
            setCoApplicantVerification({
              index: String(idx),
              data: verification,
            })
          );
        }
      });

      if (lengthOfHorizontalSteps > 0) {
        dispatch(setIsEligibilityCheckSubmitted(true));
        dispatch(setCompletedHorizontalIndex(count - 1));
        dispatch(setActiveHorizontalIndex(3));
      }

      dispatch(setCompletedHorizontalIndex(count - 1));

      navigate("/application/summary");
    } catch (e) {
      console.log(e);
    }
  };

  const handleResumeApplication = async () => {
    setIsContinueLoading(true);
    try {
      if (application?.partnerStartedJourney) {
        await handleViewSummary();
      } else {
        await handleContinue(application);
      }
    } finally {
      setIsContinueLoading(false);
    }
  };

  let appDetails: any;
  let fields: Record<string, any> = {};

  const status = application?.status;

  const canToggleProvisional =
    normalizedProvisionalOffer === "yes" ||
    normalizedProvisionalOffer === undefined ||
    (partnerStartedJourneyFlag &&
      normalizedProvisionalOffer === "no" &&
      status !== APP_STATUS.DISBURSED &&
      status !== APP_STATUS.ELIGIBILITY_FAILED &&
      status !== APP_STATUS.APPLICATION_REJECTED &&
      status !== APP_STATUS.APPLICATION_CLOSED &&
      status !== APP_STATUS.DECLINED_BY_CREDIT);

  const leadDataArr = leadDetailsData?.[application?.submissionId];
  const sanctionDataArr = sanctionDetailsData?.[application?.submissionId];
  const isSanctioned =
    application?.status?.trim().toLowerCase() ===
    normalize(APP_STATUS.SANCTIONED);
  const shouldShowValue = !application?.partnerStartedJourney || isSanctioned;

  const message = getApplicationMessage(status, normalizedProvisionalOffer, application?.partnerStartedJourney);

  if (
    application?.partnerStartedJourney &&
    Array.isArray(leadDataArr) &&
    leadDataArr.length > 0
  ) {
    // If partner started the journey → use leadDataArr
    appDetails = leadDataArr.reduce((acc: any, item: any) => {
      acc[item?.name] = item?.value || "-";
      return acc;
    }, {});
  } else {
    // Otherwise → derive from horizontalSteps
    fields = [
      ...(application.horizontalSteps?.[0]?.verticalSteps?.[0]?.fields || []),
      ...(application.horizontalSteps?.[0]?.verticalSteps?.[1]?.fields || []),
      ...(application.horizontalSteps?.[0]?.verticalSteps?.[2]?.fields || []),
    ].reduce<Record<string, any>>((acc, field) => ({ ...acc, ...field }), {});

    appDetails = {
      country: fields.country || "-",
      university: fields.university || "-",
      institute: fields.institute || "-",
      courseType: fields.courseType || "-",
      appliedLoanAmount:
        parseFloat(fields.loanAmount) && !isNaN(parseFloat(fields.loanAmount))
          ? parseFloat(fields.loanAmount).toLocaleString()
          : "-",
      createdOn: formatDateToShortMonth(application?.createdAt),
      partnerName: application?.partnerName || "-",
      salesManager: application?.assignedSMName || "-",
      // lastActionDate: formatDateToShortMonth(application?.updatedAt),
      // completionRate: "-",
      // courseName: fields.courseName || "-",
    };
  }

  const skipFields = [
    "status",
    "applicationid",
    "salesmanageremail",
    "salesmanagermobile",
    "coursename",
    "coursecategory",
    "admissionstatus",
    "totalcost",
    "product",
  ].map((i) => i.toLowerCase());
  const hiddenOnMobileFields = ["institute", "coursetype"].map((i) => i.toLowerCase());

  const loanAmountSanctioned = sanctionDataArr?.find(
    (item: any) => item?.name === "loanAmountSanctioned",
  )?.value;
  const maxTenure = sanctionDataArr?.find(
    (item: any) => item?.name === "maxTenure",
  )?.value;
  const vasAmount = sanctionDataArr?.find(
    (item: any) => item?.name === "vasAmount",
  )?.value;
  const currency = sanctionDataArr?.find(
    (item: any) => item?.name === "currency",
  )?.value;

  const formatCurrency = (value: any) => {
    const num = parseFloat(value);
    if (isNaN(num)) return "-";
    return `₹ ${new Intl.NumberFormat('en-IN').format(num)}`;
  };

  const getRepaymentLabel = (type: string) => {
    let val= typeof type === "string"  ? type?.toUpperCase():type;
    switch (val) {
      case "PINT":
        return "Partial interest";
      case "SINT":
        return "Simple interest";
      case "EMI":
        return "EMI";
      default:
        return type || "-";
    }
  };

  // Fixed helper to return specific content or null
  const getTooltipContent = (type: string) => {
    let val= typeof type === "string" ?type?.toUpperCase():type;
    switch (val) {
      case "PINT":
        return (
          <Typography variant="caption">
            <b>Partial Interest:</b> Pay a portion of the interest now; the rest is added to your principal for the next stage of your loan.
          </Typography>
        );
      case "SINT":
        return (
          <Typography variant="caption">
            <b>Simple Interest:</b> Pay full interest now; your principal repayment begins after the moratorium.
          </Typography>
        );
      default:
        return null;
    }
  };
  const activeTooltip = getTooltipContent(breData?.Repayment_Type);

  const finalLoanAmountValue =
    partnerStartedJourneyFlag && isSanctioned
      ? loanAmountSanctioned || "-"
      : (shouldShowValue && breData?.Max_Loan_Amount) || "-";

  const finalCurrencyValue =
    partnerStartedJourneyFlag && isSanctioned
      ? currency || "-"
      : (shouldShowValue && breData?.currency) || "-";

  const finalVasAmountValue =
    partnerStartedJourneyFlag && isSanctioned ? vasAmount || "-" : "-";

  const finalMaxTenureValue =
    partnerStartedJourneyFlag && isSanctioned
      ? maxTenure || "-"
      : shouldShowValue && breData?.Max_Tenure
        ? `${breData.Max_Tenure} Months`
        : "-";

  return (
    <Box>
      {isXsOrSm ? (
        <div
          key={application.submissionId}
          data-submission-id={application.submissionId}
        >
          <Box className="card-contaner-updated">
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              flexWrap="wrap"
              gap={1}
              mb={2}
              sx={{
                boxSizing: "border-box",
                width: "100%",
              }}
            >
              {/* 🎯 Left: Title and Status */}
              {![
                APP_STATUS.DECLINED_BY_CREDIT,
                APP_STATUS.APPLICATION_REJECTED,
                APP_STATUS.APPLICATION_CLOSED,
              ].includes(application?.status ?? "") &&
              application?.isEligibilityChecked !== false && (
                <Box
                  display="flex"
                  gap={1} // Reduced gap to max 4px for tight mobile screens
                  flexWrap="nowrap"
                  justifyContent="space-between"
                  alignItems="center"
                  flexShrink={0}
                  width="100%"
                >
                  <UploadButton
                    onClick={() => {
                      handleUploadDocument(application?.submissionId);
                    }}
                    sx={{
                      flex: 1, // Auto flex basis
                      minWidth: "auto !important", // Overrides default MUI Button minWidth
                      height: "32px",
                      minHeight: "unset",
                      borderRadius: "6px",
                      color: "#00b3b5",
                      borderColor: "#00b3b5",
                      fontSize: { xs: "0.68rem", sm: "0.8rem" }, // Scaled down for mobile text fit
                      padding: "2px 4px !important", // Compact padding prevents text overflow
                      whiteSpace: "nowrap",
                      textTransform: "none",
                    }}
                  >
                    <img
                      src={UploadIcon}
                      alt="Upload"
                      style={{ marginRight: "3px", height: 13, flexShrink: 0 }}
                    />
                    Upload Document
                  </UploadButton>
                  <UploadButton
                    onClick={handleViewSummary}
                    sx={{
                      flex: 1,
                      minWidth: "auto !important",
                      height: "32px",
                      minHeight: "unset",
                      borderRadius: "6px",
                      color: "#00b3b5",
                      borderColor: "#00b3b5",
                      fontSize: { xs: "0.68rem", sm: "0.8rem" },
                      padding: "2px 4px !important",
                      whiteSpace: "nowrap",
                      textTransform: "none",
                    }}
                  >
                    <img
                      src={ViewIcon}
                      alt="View Summary"
                       style={{ marginRight: "3px", height: 13, flexShrink: 0 }}
                    />
                    View Summary
                  </UploadButton>
                </Box>
              )}

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 1,
                  width: "100%",
                  overflow: "hidden",
                }}
              >
                <Box sx={{ minWidth: 0, flex: 1 }}>
                  <TruncatedTextWithTooltip
                    style={{
                      fontSize: "13px",
                      fontWeight: 600,
                      color: "#333",
                      display: "block", 
                    }}
                    text={
                      application?.partnerStartedJourney
                        ? appDetails.courseName
                        : fields.courseName || "-"
                    }
                    limit={15}
                  />
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: 600,
                      color: "#333",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    [#{application?.submissionId}]
                  </Typography>
                </Box>
                  {/* {application?.externalId && <CrmIdChip crmId={application?.externalId} label="App Id:" />} */}
                <Chip
                  label={application?.status}
                  className="card-contaner-status"
                  sx={{
                    flexShrink: 0, 
                    height: 'auto',
                    '& .MuiChip-label': { px: 1 }
                  }}
                />
              </Box>
                
            </Box>

            <Grid container spacing={3} className="card-contaner-section">
              {/* Increased spacing between details and offer box */}
              <Grid item xs={12} md={8}>
                <Grid container rowSpacing={2} columnSpacing={4}>
                  {(() => {
                    // Only for leadDetailsData-driven cards (partnerStartedJourney)
                    const isLeadDetails =
                      application?.partnerStartedJourney &&
                      Array.isArray(leadDataArr) &&
                      leadDataArr.length > 0;
                    if (!isLeadDetails) {
                      // fallback: keep old rendering
                      const SalespersonTooltipContent = (
                        <>
                          {
                            <Typography variant="caption" display="block">
                              Email: {application?.assignedSMEmail || "-"}
                            </Typography>
                          }
                          {
                            <Typography variant="caption" display="block">
                              Mobile:{" "}
                              {application?.assignedSMMobileNumber || "-"}
                            </Typography>
                          }
                        </>
                      );
                      return (
                        <>
                          {Object.entries(appDetails || {})
                            .filter(
                              ([field]) =>
                                !skipFields.includes(field.toLowerCase()) &&
                                (isXsOrSm &&
                                  !hiddenOnMobileFields.includes(
                                    field.toLowerCase(),
                                  )),
                            )
                            .map(([field, value]: any) => {
                              // Format the label once
                              const formattedLabel = field
                                ?.replace(/[_-]+/g, " ")
                                .replace(/([A-Z])/g, " $1")
                                .replace(/\s+/g, " ")
                                .replace(/^./, (str: any) => str.toUpperCase())
                                .split(" ")
                                .map(
                                  (word: any) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1),
                                )
                                .join(" ")
                                .trim();

                              // Check if label contains SM name
                              const shouldShowTooltip =
                                formattedLabel.includes("Sales Manager");

                              return (
                                <Grid
                                  item
                                  xs={6}
                                  sm={3}
                                  key={field}
                                  sx={{ textAlign: "left" }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      mb: 0.5,
                                    }}
                                  >
                                    <Typography
                                      className="card-contaner-lable"
                                      sx={{
                                        marginRight: "4px !important",
                                        marginBottom: "0 !important",
                                      }}
                                    >
                                      {formattedLabel}
                                    </Typography>

                                    {/* mobile view */}
                                    {shouldShowTooltip && (
                                      <Tooltip 
                                        title={SalespersonTooltipContent} 
                                        placement="top-start" 
                                        arrow
                                        enterTouchDelay={0}
                                        leaveTouchDelay={3000}
                                      >
                                        <Box sx={{ display: "flex", alignItems: "center", ml: 1 }}>
                                          <IconButton
                                            size="small"
                                            disableRipple
                                            sx={{
                                              p: 0,
                                              width: '0px !important',
                                              minWidth: '0px !important',
                                              height: '0px !important',
                                              background: "transparent !important",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              "&:hover, &:active": {
                                                background: "rgba(0, 0, 0, 0.04) !important",
                                                width: '0px !important',
                                                minWidth: '0px !important',
                                                height: '0px !important',
                                                p: '0px !important',
                                              },
                                            }}
                                          >
                                            <InfoOutlinedIcon
                                              sx={{
                                                fontSize: "14px",
                                                color: "#a5a3ae",
                                              }}
                                            />
                                          </IconButton>
                                        </Box>
                                      </Tooltip>
                                    )}
                                  </Box>
                                  <Typography
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      // gap: "4px",
                                    }}
                                  >
                                    <Typography
                                      style={{
                                        fontSize: "13px",
                                        color: "#6F6B7D",
                                      }}
                                    >
                                      {field === "appliedLoanAmount"
                                        ? "₹ "
                                        : ""}
                                    </Typography>

                                    <TruncatedTextWithTooltip
                                      className="card-contaner-value"
                                      text={value}
                                      // limit={isIphoneSE ? 25 : 35}
                                    />
                                  </Typography>
                                </Grid>
                              );
                            })}
                        </>
                      );
                    }

                    // For leadDetailsData-driven cards, use array for label/value rendering
                    // Find sales manager details
                    const salesManagerNameObj = leadDataArr.find(
                      (item: any) => item.name === "salesManagerName",
                    );
                    const salesManagerEmailObj = leadDataArr.find(
                      (item: any) => item.name === "salesManagerEmail",
                    );
                    const salesManagerMobileObj = leadDataArr.find(
                      (item: any) => item.name === "salesManagerMobile",
                    );
                    const salesPersonDetails = {
                      name: salesManagerNameObj?.value || "",
                      email: salesManagerEmailObj?.value || "",
                      mobile: salesManagerMobileObj?.value || "",
                    };
                    const SalespersonTooltipContent = (
                      <>
                        {salesPersonDetails && (
                          <Typography variant="caption" display="block">
                            Email: {salesPersonDetails?.email || "-"}
                          </Typography>
                        )}
                        {salesPersonDetails && (
                          <Typography variant="caption" display="block">
                            Mobile: {salesPersonDetails?.mobile || "-"}
                          </Typography>
                        )}
                      </>
                    );
                    // Filter out unwanted fields and ensure 'salesManagerName' is last
                    let filteredArr = leadDataArr.filter(
                      (item: any) =>
                        !skipFields.includes(item.name.toLowerCase())
                        && 
                          (isXsOrSm &&
                            !hiddenOnMobileFields.includes(
                            item?.name?.toLowerCase(),
                          ))
                    );
                    // Add partnerName
                    filteredArr.push({
                      name: "partnerName",
                      label: "Partner Name",
                      value: application.partnerName,
                    });
                    const salesManagerIdx = filteredArr.findIndex(
                      (item: any) => item.name === "salesManagerName",
                    );
                    if (salesManagerIdx !== -1) {
                      const [salesManagerItem] = filteredArr.splice(
                        salesManagerIdx,
                        1,
                      );
                      filteredArr.push(salesManagerItem);
                    }
                    return (
                      <>
                        {filteredArr.map((item: any, idx: number) => {
                          // Format createdOn date if present
                          const formattedItem =
                            item.name === "createdOn" && item.value
                              ? {
                                  ...item,
                                  value: formatDateToShortMonth(item.value),
                                }
                              : item;
                          return (
                            <Grid
                              item
                              xs={6}
                              sm={3}
                              key={item.name}
                              sx={{ textAlign: "left" }}
                            >
                              {/* when partnerstartedjourney true */}
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                }}
                              >
                                <Typography className="card-contaner-lable">
                                  {item.label
                                    ?.replace(/[_-]+/g, " ")
                                    .replace(/([A-Z])/g, " $1")
                                    .replace(/\s+/g, " ")
                                    .replace(/^./, (str: any) => str.toUpperCase())
                                    .split(" ")
                                    .map(
                                      (word: any) =>
                                        word.charAt(0).toUpperCase() + word.slice(1)
                                    )
                                    .join(" ")
                                    .replace("Sales Manager Name", "Sales Manager")
                                    .trim()
                                  }
                                </Typography>
                                {item.label === "Sales Manager Name" &&
                                  (salesPersonDetails.email ||
                                    salesPersonDetails.mobile) && (
                                    <Tooltip
                                      title={SalespersonTooltipContent}
                                      placement="top-start" 
                                      arrow
                                      enterTouchDelay={0}
                                      leaveTouchDelay={3000}
                                    >
                                      <Box sx={{ display: "flex", alignItems: "center", ml: 1, mb: 1 }}>
                                        <IconButton
                                          size="small"
                                          sx={{
                                            p: 0,
                                            width: '0px !important',
                                            minWidth: '0px !important',
                                            height: '0px !important',
                                            background: "transparent !important",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            "&:hover, &:active": {
                                              background: "rgba(0, 0, 0, 0.04) !important",
                                              width: '0px !important',
                                              minWidth: '0px !important',
                                              height: '0px !important',
                                              p: '0px !important',
                                            },
                                          }}
                                          aria-label="Salesperson contact details"
                                        >
                                          <InfoOutlinedIcon
                                            sx={{
                                              fontSize: "14px",
                                              color: "#a5a3ae",
                                              cursor: "pointer",
                                            }}
                                          />
                                        </IconButton>
                                      </Box>
                                    </Tooltip>
                                  )}
                              </Box>
                              <TruncatedTextWithTooltip
                                className="card-contaner-value"
                                text={formattedItem.value}
                                // limit={15}
                              />
                            </Grid>
                          );
                        })}
                      </>
                    );
                  })()}
                </Grid>
              </Grid>
              <Grid item xs={12} md={4}>
                <div
                  className={`${
                    !partnerStartedJourneyFlag &&
                    normalizedProvisionalOffer === "yes"
                      ? "right-side-box-provision"
                      : partnerStartedJourneyFlag &&
                          (application?.status === APP_STATUS.DISBURSED ||
                            application?.status === APP_STATUS.SANCTIONED)
                        ? "right-side-box-provision"
                        : "right-side-box"
                  } `}
                  style={isXsOrSm ? {} : {minHeight: "170px" }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    onClick={
                      canToggleProvisional
                        ? () =>
                            setIsProvisionalOfferExpanded(
                              !isProvisionalOfferExpanded,
                            )
                        : undefined
                    }
                    sx={{
                      cursor: canToggleProvisional ? "pointer" : "default",
                    }}
                  >
                    <Grid sx={{ display: "flex", alignItems: "center" }}>
                      {application?.status === APP_STATUS.SANCTIONED ? (
                        <img
                          src={
                            !partnerStartedJourneyFlag &&
                            normalizedProvisionalOffer === "yes"
                              ? textFile
                              : LockSquare
                          }
                          alt="lock-square"
                        />
                      ) : !partnerStartedJourneyFlag &&
                        normalizedProvisionalOffer === "no" ? null : (
                        <>
                          {application?.isEligibilityChecked !== false && application?.status !== APP_STATUS.DISBURSED &&
                            application?.status !==
                              APP_STATUS.ELIGIBILITY_FAILED &&
                            application?.status !==
                              APP_STATUS.APPLICATION_REJECTED &&
                            application?.status !==
                              APP_STATUS.APPLICATION_CLOSED &&
                            application?.status !==
                              APP_STATUS.DECLINED_BY_CREDIT && (
                              <img
                                src={
                                  !partnerStartedJourneyFlag &&
                                  normalizedProvisionalOffer === "yes"
                                    ? textFile
                                    : LockSquare
                                }
                                alt="lock-square"
                              />
                            )}
                        </>
                      )}
                      {/* Icon */}
                      <Typography
                        // className="right-side-heading"
                        sx={{
                          ml: 1.5,
                          mr: 1,
                          fontSize: "15px",
                          fontWeight: 600,
                          color: "#333",
                        }}
                      >
                        {application?.isEligibilityChecked !== null && !application?.isEligibilityChecked ? STATUS_MESSAGES?.ELIGIBILITY_CHECK_FAILED : message}
                      </Typography>
                    </Grid>

                    {application?.status === APP_STATUS.SANCTIONED ? (
                      <Box sx={{ cursor: "pointer", pt: 1 }}>
                        {isProvisionalOfferExpanded ? (
                          <KeyboardArrowUpIcon
                            sx={{ color: "rgba(0, 179, 181, 1)" }}
                          />
                        ) : (
                          <KeyboardArrowDownIcon
                            sx={{ color: "rgba(0, 179, 181, 1)" }}
                          />
                        )}
                      </Box>
                    ) : !partnerStartedJourneyFlag &&
                      normalizedProvisionalOffer === "no" ? null : (
                      <>
                        {application?.isEligibilityChecked !== false && application?.status !== APP_STATUS.DISBURSED &&
                          application?.status !==
                            APP_STATUS.ELIGIBILITY_FAILED &&
                          application?.status !==
                            APP_STATUS.APPLICATION_REJECTED &&
                          application?.status !==
                            APP_STATUS.APPLICATION_CLOSED &&
                          application?.status !==
                            APP_STATUS.DECLINED_BY_CREDIT && (
                            <Box sx={{ cursor: "pointer", pt: 1 }}>
                              {isProvisionalOfferExpanded ? (
                                <KeyboardArrowUpIcon
                                  sx={{ color: "rgba(0, 179, 181, 1)" }}
                                />
                              ) : (
                                <KeyboardArrowDownIcon
                                  sx={{ color: "rgba(0, 179, 181, 1)" }}
                                />
                              )}
                            </Box>
                          )}
                      </>
                    )}
                  </Box>

                  {isProvisionalOfferExpanded &&
                  application?.status === APP_STATUS.SANCTIONED ? (
                    <Grid container spacing={2} mt={1}>
                      <Grid item xs={6}>
                        <Typography className="right-side-lable">
                          {partnerStartedJourneyFlag
                            ? "Loan Amount"
                            : "Offer loan amount"}
                        </Typography>
                        <Typography className="right-side-value">
                          {formatCurrency(finalLoanAmountValue)}
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <Typography className="right-side-lable">
                          Tenure
                        </Typography>
                        <Typography className="right-side-value">
                          {finalMaxTenureValue}
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <Typography className="right-side-lable">
                          {partnerStartedJourneyFlag && isSanctioned
                            ? "VAS Amount"
                            : "Repayment type"}
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <Typography className="right-side-value" sx={{ textTransform: 'capitalize' }}>
                            {partnerStartedJourneyFlag && isSanctioned
                              ? formatCurrency(finalVasAmountValue)
                              : (shouldShowValue && getRepaymentLabel(breData?.Repayment_Type)) || "-"
                            }
                          </Typography>
                          
                          {!partnerStartedJourneyFlag && breData?.Repayment_Type && (
                            <Tooltip 
                              title={<Box sx={{ p: 0.5 }}>{activeTooltip}</Box>} 
                              arrow 
                              placement="top"
                              enterTouchDelay={0}
                              leaveTouchDelay={3000} 
                            >
                              <InfoOutlined 
                                sx={{ 
                                  fontSize: "16px", 
                                  cursor: "pointer", 
                                  color: "action.active",
                                  userSelect: "auto",
                                  WebkitUserSelect: "auto" 
                                }} 
                              />
                            </Tooltip>
                          )}
                        </Box>
                      </Grid>

                      <Grid item xs={6}>
                        <Typography className="right-side-lable">
                          Currency
                        </Typography>
                        <Typography className="right-side-value">
                          {finalCurrencyValue}
                        </Typography>
                      </Grid>
                    </Grid>
                  ) : !partnerStartedJourneyFlag &&
                    normalizedProvisionalOffer === "no" ? null : (
                    <>
                      {isProvisionalOfferExpanded &&
                      application?.isEligibilityChecked !== false &&
                        application?.status !== APP_STATUS.DISBURSED &&
                        application?.status !== APP_STATUS.ELIGIBILITY_FAILED &&
                        application?.status !==
                          APP_STATUS.APPLICATION_REJECTED &&
                        application?.status !== APP_STATUS.APPLICATION_CLOSED &&
                        application?.status !==
                          APP_STATUS.DECLINED_BY_CREDIT && (
                          <Grid container spacing={2} mt={1}>
                            <Grid item xs={6}>
                              <Typography className="right-side-lable">
                                {partnerStartedJourneyFlag
                                  ? "Loan Amount"
                                  : "Offer loan amount"}
                              </Typography>
                              <Typography className="right-side-value">
                                {formatCurrency(finalLoanAmountValue)}
                              </Typography>
                            </Grid>

                            <Grid item xs={6}>
                              <Typography className="right-side-lable">
                                Tenure
                              </Typography>
                              <Typography className="right-side-value">
                                {finalMaxTenureValue}
                              </Typography>
                            </Grid>

                            <Grid item xs={6}>
                              <Typography className="right-side-lable">
                                {partnerStartedJourneyFlag && isSanctioned
                                  ? "VAS Amount"
                                  : "Repayment type"}
                              </Typography>
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <Typography className="right-side-value" sx={{ textTransform: 'capitalize' }}>
                                  {partnerStartedJourneyFlag && isSanctioned
                                    ? formatCurrency(finalVasAmountValue)
                                    : (shouldShowValue && getRepaymentLabel(breData?.Repayment_Type)) || "-"
                                  }
                                </Typography>
                                
                                {!partnerStartedJourneyFlag && breData?.Repayment_Type && (
                                  <Tooltip 
                                    title={<Box sx={{ p: 0.5 }}>{activeTooltip}</Box>} 
                                    arrow 
                                    placement="top"
                                    enterTouchDelay={0}
                                    leaveTouchDelay={3000} 
                                  >
                                    <InfoOutlined 
                                      sx={{ 
                                        fontSize: "16px", 
                                        cursor: "pointer", 
                                        color: "action.active",
                                        userSelect: "auto",
                                        WebkitUserSelect: "auto" 
                                      }} 
                                    />
                                  </Tooltip>
                                )}
                              </Box>
                            </Grid>

                            <Grid item xs={6}>
                              <Typography className="right-side-lable">
                                Currency
                              </Typography>
                              <Typography className="right-side-value">
                                {finalCurrencyValue}
                              </Typography>
                            </Grid>
                          </Grid>
                        )}
                    </>
                  )}
                </div>
              </Grid>
            </Grid>

            <SalesManagerContact
              name={application?.assignedSMName}
              mobile={application?.assignedSMMobileNumber}
              email={application?.assignedSMEmail}
              partnerName={application?.partnerName}
              trackingId={application?.submissionId}
              onCallbackResult={({ message, severity }) =>
                dispatch(setStatusPopup({ status: severity, message }))
              }
            />
            <Box sx={{ mt: 2, mb: 2 }}>
              <NextStepBanner
                status={application?.status || ""}
                managerName={application?.assignedSMName}
                onResume={handleResumeApplication}
                isResumeLoading={isContinueLoading}
                completedSteps={finalSteps.filter(
                  (step: any) => step?.status === "completed" || step?.isCompleted
                ).length}
                totalSteps={finalSteps.length}
              />
            </Box>   
            {/* === Application Progress Stepper (Mobile Accordion) === */}

            <ApplicationProgressStepper
              data={finalSteps}
              activeStep={activeStep}
              isLoading={isSliderLoading}
              partnerStartedJourney={application?.partnerStartedJourney}
            />

            {![
              APP_STATUS.DECLINED_BY_CREDIT,
              APP_STATUS.APPLICATION_REJECTED,
              APP_STATUS.APPLICATION_CLOSED,
              ].includes(application?.status ?? "") &&
             application?.isEligibilityChecked !== false && (
              <IconButton
                sx={{
                  height: "32px",
                  width: "100%",
                  "&:hover": {
                    width: "100%",
                  },
                }}
                onClick={() =>application?.partnerStartedJourney===true?handleViewSummary():handleContinue(application)
                }
                disabled={isContinueLoading}
              >
                {isContinueLoading ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <CircularProgress size={16} sx={{ color: "#1F2233" }} />
                    <span>Loading...</span>
                  </Box>
                ) : (
                  "Continue"
                )}
              </IconButton>
            )}
          </Box>
        </div>
      ) : (
        <div
          className="card-contaner"
          data-submission-id={application.submissionId}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between" // Distribute space
            flexWrap="wrap"
            gap={2} // Gap between title/chip and buttons
            mb={1}
          >
            {/* 🎯 Left: Title and Status */}
            <Box display="flex" alignItems="center" gap={1} flexShrink={1}>
              <TruncatedTextWithTooltip
                className="card-contaner-hedging"
                text={
                  application?.partnerStartedJourney
                    ? appDetails.courseName
                    : fields.courseName || "-"
                }
                limit={15}
              />
              <Typography className="card-contaner-hedging">
                [#{application?.submissionId}]
              </Typography>
              {application?.externalId && <CrmIdChip crmId={application?.externalId} label="App Id:" />}
              
              <Chip
                label={application?.status}
                className="card-contaner-status"
              />
            </Box>

            {/* 🟦 Right: Action Buttons */}
            {
            ![
              APP_STATUS.DECLINED_BY_CREDIT,
              APP_STATUS.APPLICATION_REJECTED,
              APP_STATUS.APPLICATION_CLOSED,
              ].includes(application?.status ?? "") &&
            application?.isEligibilityChecked !== false && (
              <Box
                display="flex"
                gap={1.5} // Smaller gap between buttons
                flexWrap="wrap"
                justifyContent="flex-end" // Align buttons to the right
                alignItems="center"
                flexShrink={0}
              >
                <UploadButton
                  onClick={() => {
                    handleUploadDocument(application?.submissionId);
                  }}
                  sx={{
                    textTransform: "none",
                    borderColor: "#00b3b5",
                    color: "#00b3b5",
                    "&:hover": {
                      borderColor: "#00999a",
                      bgcolor: "#e0f7fa",
                    },
                    px: 1.5,
                    py: 0.5,
                    borderRadius: "8px",
                    fontSize: "0.8rem",
                    minWidth: "auto",
                    whiteSpace: "nowrap",
                  }}
                >
                  <img
                    src={UploadIcon}
                    alt="Upload"
                    style={{ marginRight: "5px", height: 16 }}
                  />
                  Upload Document
                </UploadButton>
                <UploadButton
                  onClick={handleViewSummary}
                  sx={{
                    textTransform: "none",
                    borderColor: "#00b3b5",
                    color: "#00b3b5",
                    "&:hover": {
                      borderColor: "#00999a",
                      bgcolor: "#e0f7fa",
                    },
                    px: 1.5,
                    py: 0.5,
                    borderRadius: "8px",
                    fontSize: "0.8rem",
                    minWidth: "auto",
                    whiteSpace: "nowrap",
                  }}
                >
                  <img
                    src={ViewIcon}
                    alt="View Summary"
                    style={{ marginRight: "5px", height: 16 }}
                  />
                  View Summary
                </UploadButton>

                <IconButton
                  sx={{ height: "26px" }}
                  onClick={() =>application?.partnerStartedJourney===true?handleViewSummary(): handleContinue(application)
                    }
                  disabled={isContinueLoading}
                >
                  {isContinueLoading ? (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <CircularProgress size={14} sx={{ color: "#1F2233" }} />
                      <span>Loading...</span>
                    </Box>
                  ) : (
                    "Continue"
                  )}
                </IconButton>
              </Box>
            )}
          </Box>

          <CustomDivider />

          {/* === Application Details === */}
          <Grid
            container
            spacing={2}
            justifyContent={"space-between"}
            alignItems={"stretch"}
            className="card-contaner-section"
          >
            <Grid item xs={12} md={7.5}>
              <Typography className="card-section-hedging">
                Application Details
              </Typography>

              <Grid container rowSpacing={2} columnSpacing={4}>
                {/* --- Sales Manager Tooltip logic --- */}
                {(() => {
                  // Only for leadDetailsData-driven cards (partnerStartedJourney)
                  const isLeadDetails =
                    application?.partnerStartedJourney &&
                    Array.isArray(leadDataArr) &&
                    leadDataArr.length > 0;
                  if (!isLeadDetails) {
                    // fallback: keep old rendering
                    const SalespersonTooltipContent = (
                      <>
                        {
                          <Typography variant="caption" display="block">
                            Email: {application?.assignedSMEmail || "-"}
                          </Typography>
                        }
                        {
                          <Typography variant="caption" display="block">
                            Mobile: {application?.assignedSMMobileNumber || "-"}
                          </Typography>
                        }
                      </>
                    );
                    return (
                      <>
                        {Object.entries(appDetails || {})
                          .filter(
                            ([field]) =>
                              !skipFields.includes(field.toLowerCase()),
                          )
                          .map(([field, value]: any) => {
                            const formattedLabel = field
                              ?.replace(/[_-]+/g, " ")
                              .replace(/([A-Z])/g, " $1")
                              .replace(/\s+/g, " ")
                              .replace(/^./, (str: any) => str.toUpperCase())
                              .split(" ")
                              .map(
                                (word: any) =>
                                  word.charAt(0).toUpperCase() + word.slice(1),
                              )
                              .join(" ")
                              .trim();

                            // Check if label contains SM name
                            const shouldShowTooltip =
                              formattedLabel.includes("Sales Manager");
                            return (
                              <Grid
                                item
                                xs={6}
                                sm={3}
                                key={field}
                                sx={{ textAlign: "left" }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    mb: 0.5,
                                  }}
                                >
                                  <Typography
                                    className="card-contaner-lable"
                                    sx={{
                                      marginRight: "4px !important",
                                      marginBottom: "0 !important",
                                    }}
                                  >
                                    {formattedLabel}
                                  </Typography>

                                  {shouldShowTooltip && (
                                    <Tooltip title={SalespersonTooltipContent} placement="top-start" arrow>
                                      <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer", ml: 1 }}>
                                        <IconButton
                                          size="small"
                                          disableRipple
                                          sx={{
                                            p: 0,
                                            width: '0px !important',
                                              minWidth: '0px !important',
                                              height: '0px !important',
                                            background: "transparent !important",
                                            "&:hover": {
                                              background: "transparent !important",
                                              p: '0px !important',
                                              width: '0px !important',
                                              minWidth: '0px !important',
                                              height: '0px !important',
                                            },
                                          }}
                                        >
                                          <InfoOutlinedIcon
                                            sx={{
                                              fontSize: "14px",
                                              color: "#a5a3ae",
                                            }}
                                          />
                                        </IconButton>
                                      </Box>
                                    </Tooltip>
                                  )}
                                </Box>
                                <Typography
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    // gap: "4px",
                                  }}
                                >
                                  <Typography
                                    style={{
                                      fontSize: "13px",
                                      color: "#6F6B7D",
                                    }}
                                  >
                                    {field === "appliedLoanAmount" ? "₹ " : ""}
                                  </Typography>

                                  <TruncatedTextWithTooltip
                                    className="card-contaner-value"
                                    text={value}
                                    // limit={isIphoneSE ? 25 : 35}
                                  />
                                </Typography>
                              </Grid>
                            );
                          })}
                      </>
                    );
                  }

                  // For leadDetailsData-driven cards, use array for label/value rendering
                  // Find sales manager details
                  const salesManagerNameObj = leadDataArr.find(
                    (item: any) => item.name === "salesManagerName",
                  );
                  const salesManagerEmailObj = leadDataArr.find(
                    (item: any) => item.name === "salesManagerEmail",
                  );
                  const salesManagerMobileObj = leadDataArr.find(
                    (item: any) => item.name === "salesManagerMobile",
                  );
                  const salesPersonDetails = {
                    name: salesManagerNameObj?.value || "",
                    email: salesManagerEmailObj?.value || "",
                    mobile: salesManagerMobileObj?.value || "",
                  };
                  const SalespersonTooltipContent = (
                    <>
                      {salesPersonDetails && (
                        <Typography variant="caption" display="block">
                          Email: {salesPersonDetails?.email || "-"}
                        </Typography>
                      )}
                      {salesPersonDetails && (
                        <Typography variant="caption" display="block">
                          Mobile: {salesPersonDetails?.mobile || "-"}
                        </Typography>
                      )}
                    </>
                  );
                  // Filter out unwanted fields and ensure 'salesManagerName' is last
                  let filteredArr = leadDataArr.filter(
                    (item: any) =>
                      !skipFields.includes(item.name.toLowerCase()),
                  );
                  // Add partnerName
                  filteredArr.push({
                    name: "partnerName",
                    label: "Partner Name",
                    value: application.partnerName,
                  });
                  const salesManagerIdx = filteredArr.findIndex(
                    (item: any) => item.name === "salesManagerName",
                  );
                  if (salesManagerIdx !== -1) {
                    const [salesManagerItem] = filteredArr.splice(
                      salesManagerIdx,
                      1,
                    );
                    filteredArr.push(salesManagerItem);
                  }
                  return (
                    <>
                      {filteredArr == null || filteredArr?.length === 0
                        ? Array.from({ length: 8 }).map((_, index) => (
                            <Grid item xs={12} sm={6} md={3} key={index}>
                              <Skeleton
                                variant="text"
                                sx={{ fontSize: "1rem" }}
                                width="80%"
                              />
                              <Skeleton
                                variant="text"
                                sx={{ fontSize: "1rem" }}
                                width="60%"
                              />
                            </Grid>
                          ))
                        : filteredArr.map((item: any, index: any) => {
                            // Format createdOn date if present
                            const formattedItem =
                              item.name === "createdOn" && item.value
                                ? {
                                    ...item,
                                    value: formatDateToShortMonth(item.value),
                                  }
                                : item;
                            return (
                              <Grid item xs={12} sm={6} md={3} key={item.label}>
                                <DetailRow
                                  item={formattedItem}
                                  showInfoIcon={
                                    item.label === "Sales Manager Name" &&
                                    (salesPersonDetails?.email ||
                                      salesPersonDetails?.mobile)
                                      ? true
                                      : false
                                  }
                                  salespersonTooltipContent={
                                    SalespersonTooltipContent
                                  }
                                />
                              </Grid>
                            );
                          })}
                    </>
                  );
                })()}
              </Grid>
            </Grid>

            <Grid item xs={12} md={4.5} sx={{ display: "flex", gap: 1.5 }}>
              <Grid item sx={{}}>
                <CustomDivider isVertical={true} />
              </Grid>

              {(() => {
                return (
                  <>
                    {
                      application?.isEligibilityChecked !== null && !application?.isEligibilityChecked ?  (
                      <>
                        <div
                          className="right-side-box"
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Grid
                            container
                            spacing={2}
                            sx={{
                              textAlign: "center",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              px: '10px'
                            }}
                          >
                            <Typography
                              className="right-side-heading"
                              sx={{ mb: 0 }}
                            >
                              {STATUS_MESSAGES?.ELIGIBILITY_CHECK_FAILED}
                            </Typography>
                          </Grid>
                        </div>
                      </>
                    ) : 
                    application?.status === APP_STATUS.SANCTIONED ? (
                      <div
                        className={
                          (!partnerStartedJourneyFlag &&
                            normalizedProvisionalOffer === "yes") ||
                          application?.status === APP_STATUS.SANCTIONED ||
                          application?.status === APP_STATUS.DISBURSED
                            ? "right-side-box-provision"
                            : "right-side-box"
                        }
                       style={isXsOrSm ? {width: "100%"} : {width: "100%",minHeight: "170px" }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            mb: 2,
                          }}
                        >
                          <img
                            src={
                              !partnerStartedJourneyFlag &&
                              normalizedProvisionalOffer === "yes"
                                ? textFile
                                : LockSquare
                            }
                            alt="lock-square"
                          />
                          <Typography className="right-side-heading">
                            {message}
                          </Typography>
                        </Box>

                        <Grid container spacing={2} sx={{ textAlign: "left" }}>
                          <Grid item xs={12} sm={6}>
                            <Typography className="right-side-lable">
                              {partnerStartedJourneyFlag
                                ? "Loan Amount"
                                : "Offer loan amount"}
                            </Typography>
                            <Typography className="right-side-value">
                              {formatCurrency(finalLoanAmountValue)}
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <Typography className="right-side-lable">
                              Tenure
                            </Typography>
                            <Typography className="right-side-value">
                              {finalMaxTenureValue}
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <Typography className="right-side-lable">
                              {partnerStartedJourneyFlag && isSanctioned
                                ? "VAS Amount"
                                : "Repayment type"}
                            </Typography>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <Typography className="right-side-value" sx={{ textTransform: 'capitalize' }}>
                                {partnerStartedJourneyFlag && isSanctioned
                                  ? formatCurrency(finalVasAmountValue)
                                  : (shouldShowValue && getRepaymentLabel(breData?.Repayment_Type)) || "-"
                                }
                              </Typography>
                              
                              {!partnerStartedJourneyFlag && breData?.Repayment_Type && (
                                <Tooltip 
                                  title={<Box sx={{ p: 0.5 }}>{activeTooltip}</Box>} 
                                  arrow 
                                  placement="top"
                                  enterTouchDelay={0}
                                  leaveTouchDelay={3000} 
                                >
                                  <InfoOutlined 
                                    sx={{ 
                                      fontSize: "16px", 
                                      cursor: "pointer", 
                                      color: "action.active",
                                      userSelect: "auto",
                                      WebkitUserSelect: "auto" 
                                    }} 
                                  />
                                </Tooltip>
                              )}
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <Typography className="right-side-lable">
                              Currency
                            </Typography>
                            <Typography className="right-side-value">
                              {finalCurrencyValue}
                            </Typography>
                          </Grid>
                        </Grid>
                      </div>
                    ) : !partnerStartedJourneyFlag &&
                      normalizedProvisionalOffer === "no" ? (
                      <>
                        <div
                          className={
                            application?.status === APP_STATUS.SANCTIONED ||
                            application?.status === APP_STATUS.DISBURSED
                              ? "right-side-box-provision"
                              : "right-side-box"
                          }
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            ...(isXsOrSm ? {} : {minHeight: "170px" }),
                          }}
                        >
                          <Grid
                            container
                            spacing={2}
                            sx={{
                              textAlign: "center",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              px: '10px'
                            }}
                          >
                            <Typography
                              className="right-side-heading"
                              sx={{ mb: 0 }}
                            >
                              {message}
                            </Typography>
                          </Grid>
                        </div>
                      </>
                    ) : application?.status !== APP_STATUS.DISBURSED &&
                      application?.status !== APP_STATUS.ELIGIBILITY_FAILED &&
                      application?.status !== APP_STATUS.APPLICATION_REJECTED &&
                      application?.status !== APP_STATUS.APPLICATION_CLOSED &&
                      application?.status !== APP_STATUS.DECLINED_BY_CREDIT ? (
                      <div
                        className={
                          (!partnerStartedJourneyFlag &&
                            normalizedProvisionalOffer === "yes") ||
                          application?.status === APP_STATUS.SANCTIONED ||
                          application?.status === APP_STATUS.DISBURSED
                            ? "right-side-box-provision"
                            : "right-side-box"
                        }
                        style={isXsOrSm ? {width: "100%"} : {width: "100%",minHeight: "170px" }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            mb: 2,
                          }}
                        >
                          <img
                            src={
                              !partnerStartedJourneyFlag &&
                              normalizedProvisionalOffer === "yes"
                                ? textFile
                                : LockSquare
                            }
                            alt="lock-square"
                          />
                          <Typography className="right-side-heading">
                            {message}
                          </Typography>
                        </Box>

                        <Grid container spacing={2} sx={{ textAlign: "left" }}>
                          <Grid item xs={12} sm={6}>
                            <Typography className="right-side-lable">
                              {partnerStartedJourneyFlag
                                ? "Loan Amount"
                                : "Offer loan amount"}
                            </Typography>
                            <Typography className="right-side-value">
                              {formatCurrency(finalLoanAmountValue)}
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <Typography className="right-side-lable">
                              Tenure
                            </Typography>
                            <Typography className="right-side-value">
                              {finalMaxTenureValue}
                            </Typography>
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <Typography className="right-side-lable">
                              {partnerStartedJourneyFlag && isSanctioned
                                ? "VAS Amount"
                                : "Repayment type"}
                            </Typography>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <Typography className="right-side-value" sx={{ textTransform: 'capitalize' }}>
                                {partnerStartedJourneyFlag && isSanctioned
                                  ? formatCurrency(finalVasAmountValue)
                                  : (shouldShowValue && getRepaymentLabel(breData?.Repayment_Type)) || "-"
                                }
                              </Typography>
                              
                              {!partnerStartedJourneyFlag && breData?.Repayment_Type && (
                                <Tooltip 
                                  title={<Box sx={{ p: 0.5 }}>{activeTooltip}</Box>} 
                                  arrow 
                                  placement="top"
                                  enterTouchDelay={0}
                                  leaveTouchDelay={3000} 
                                >
                                  <InfoOutlined 
                                    sx={{ 
                                      fontSize: "16px", 
                                      cursor: "pointer", 
                                      color: "action.active",
                                      userSelect: "auto",
                                      WebkitUserSelect: "auto" 
                                    }} 
                                  />
                                </Tooltip>
                              )}
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <Typography className="right-side-lable">
                              Currency
                            </Typography>
                            <Typography className="right-side-value">
                              {finalCurrencyValue}
                            </Typography>
                          </Grid>
                        </Grid>
                      </div>
                    ) : (
                      <>
                        <div
                          className={
                            application?.status === APP_STATUS.SANCTIONED ||
                            application?.status === APP_STATUS.DISBURSED
                              ? "right-side-box-provision"
                              : "right-side-box"
                          }
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            ...(isXsOrSm ? {} : {minHeight: "170px" }), 
                          }}
                        >
                          <Grid
                            container
                            spacing={2}
                            sx={{
                              textAlign: "center",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              px: '10px'
                            }}
                          >
                            <Typography
                              className="right-side-heading"
                              sx={{ mb: 0 }}
                            >
                              {message}
                            </Typography>
                          </Grid>
                        </div>
                      </>
                    )}
                  </>
                );
              })()}
            </Grid>
          </Grid>

          <CustomDivider />
          <NextStepBanner
            status={application?.status || ""}
            managerName={application?.assignedSMName}
            onResume={handleResumeApplication}
            isResumeLoading={isContinueLoading}
            completedSteps={finalSteps.filter(
              (step: any) => step?.status === "completed" || step?.isCompleted
            ).length}
            totalSteps={finalSteps.length}
          />

          {/* Application Progress (Desktop Stepper) */}
          <Grid container spacing={3} className="card-contaner-section">
            <ApplicationProgressStepper
              data={finalSteps}
              activeStep={activeStep}
              isLoading={isSliderLoading}
              partnerStartedJourney={application?.partnerStartedJourney}
            />
          </Grid>
        </div>
      )}
    </Box>
  );
};

// --- Main ViewAllApplications Component ---
const ViewAllApplications: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  const isIphoneSE = useMediaQuery(`(max-width: 400px)`);
  const [applications, setApplications] = useState<any[]>([]);
  const [statusFilter, setStatusFilter] = useState<string>("all");
  const [isSliderLoading, setIsSliderLoading] = useState(true);
  const lastScrollY = useRef(0);
  const throttleTimeout = useRef<NodeJS.Timeout | null>(null);
  const seenSubmissionIds = useRef<Set<string>>(new Set());
  const [breData, setBreData] = useState<any>({});
  // Store lead details response by applicationId
   const deviceType = sessionStorage.getItem("deviceType");
  const [leadDetailsData, setLeadDetailsData] = useState<Record<string, any>>(
    {}
  );
  // Store sanction details response by applicationId
  const [sanctionDetailsData, setSanctionDetailsData] = useState<Record<string, any>>(
    {}
  );
  // Pagination state
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [totalApplications, setTotalApplications] = useState<number>(0);
  const itemsPerPage = 3;
  const breadcrumbItems = [
    { label: "Dashboard", path: "/application/existing-application" },
    { label: "All Applications" }, // Current page, no `path` needed
  ];

  // Function to get current viewing progress
  const getViewingProgress = useCallback(() => {
    const totalApplications = applications.length;
    const viewedApplications = seenSubmissionIds.current.size;
    const progressPercentage =
      totalApplications > 0
        ? (viewedApplications / totalApplications) * 100
        : 0;

    return {
      viewed: viewedApplications,
      total: totalApplications,
      percentage: Math.round(progressPercentage),
      remaining: totalApplications - viewedApplications,
    };
  }, [applications.length]);
  const handleBreInvokApi = async (trackingId: string, application: any) => {
    const oldBreData: any = { ...breData };
    try {
      const payload = {
        applicationId: trackingId,
        name:
          application?.horizontalSteps?.length > 1
            ? "getProvisionalOffer"
            : "getCustomerEligibility",
      };

      const res: any = await eligibilityCheckServices.fetchBreApi(payload);
      oldBreData[trackingId] = res?.data?.data;
      setBreData((prev: any) => ({ ...prev, ...oldBreData }));
    } catch (e) {
      console.log(e);
    }
  };

  // Function to be called when scrolling down
  const handleScrollDown = useCallback(() => {
    // Get all application cards that are currently visible
    const applicationCards = document.querySelectorAll("[data-submission-id]");
    const newlyVisibleSubmissionIds: string[] = [];
    const allVisibleSubmissionIds: string[] = [];

    applicationCards.forEach((card) => {
      const rect = card.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

      if (isVisible) {
        const submissionId = card.getAttribute("data-submission-id");
        if (
          submissionId &&
          !submissionId.startsWith("loading-") &&
          submissionId !== "no-data"
        ) {
          allVisibleSubmissionIds.push(submissionId);

          // Check if this is a newly visible submission ID
          if (!seenSubmissionIds.current.has(submissionId)) {
            newlyVisibleSubmissionIds.push(submissionId);
            seenSubmissionIds.current.add(submissionId);
          }
        }
      }
    });

    // Get current viewing progress
    const progress = getViewingProgress();
    // Only track newly visible submission IDs, no BRE API calls on scroll
  }, [getViewingProgress]);

  // Call with (leadId, submissionId)
  const getLeadDetails = async (leadId: string, applicationNumber: string) => {
    const payload = {
      leadId: leadId,
      trackingId: applicationNumber,
    };
    try {
      const res: any = await eligibilityCheckServices.partnerGetLeadDetailsApi(
        payload
      );
      const details = res?.data?.data?.applicationDetails;
      const sanctionDetails = res?.data?.data?.sanctionDetails;
      if (details) {
        const getValue = (list: any[], key: string): string =>
          list.find((item) => item.name === key)?.value ?? "";

        setLeadDetailsData((prev) => ({
          ...prev,
          [applicationNumber]: details,
        }));

        setSanctionDetailsData((prev) => ({
          ...prev,
          [applicationNumber]: sanctionDetails,
        }));
      }
      dispatch(
        setCoApplicantDetails(
          res?.data?.data?.["Co-applicantDetails"]?.["co-applicants"],
        ),
      );
    } catch (e) {
      console.error("getLeadDetails error", e);
    }
  };
  const isAuthenticated = useSelector(authStatusSelector);
  useEffect(() => {
    const fetchData = async () => {
      setIsSliderLoading(true);
      try {
        const token: any = process.env.REACT_APP_FETCH_TOKEN;
        const res: any = await fetchUserApplications(
          token,
          statusFilter !== "all" ? statusFilter : "",
          currentPage,
          itemsPerPage
        );
        const apps = res?.data?.applications || [];
        dispatch(clearFormData());
        setApplications(apps);

        // Update pagination metadata
        if (res?.data?.pagination?.totalItems !== undefined) {
          setTotalApplications(res.data.pagination.totalItems);
          setTotalPages(
            Math.ceil(res.data.pagination.totalItems / itemsPerPage)
          );
        }

        // Call getLeadDetails for applications with partnerStartedJourney:true
        for (const app of apps) {
          if (app.partnerStartedJourney && app.leadId && app.submissionId) {
            await getLeadDetails(app.leadId, app.submissionId);
          }
        }

        // Call BRE API for all applications on page load
        for (const app of apps) {
          if (app.submissionId) {
            await handleBreInvokApi(app.submissionId, app);
          }
        }

        // Reset seen submission IDs when applications change
        seenSubmissionIds.current.clear();
      } catch (e) {
        console.log(e);
      } finally {
        setIsSliderLoading(false);
        
        // Call handleScrollDown after data is loaded to track initially visible applications
        setTimeout(() => {
          handleScrollDown();
        }, 100);
      }
    };

    fetchData();
  }, [statusFilter, currentPage, handleScrollDown]);

  // Scroll event listener removed - BRE API now only called on page load

  const findActiveStep = (finalSteps: CombinedStep[]): number => {
    for (let i = finalSteps.length - 1; i >= 0; i--) {
      const step = finalSteps[i];
      if (
        step.completionRate === 100 &&
        step.status.toLowerCase() === "completed"
      ) {
        return i + 1;
      }
    }
    return -1;
  };

  return (
    <Grid className="existing-application">
      <Box sx={{ width: "100%", padding: "0px 0px 18px 0px", 
        marginTop: isDeviceTypeMobile(isXsOrSm) ? 10 :0 }}>
        <Breadcrumbs items={breadcrumbItems} />
      </Box>

      {/* Header */}
      <Box
        sx={{
          marginBottom: "5px",
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          // mt: isDeviceTypeMobile(isXsOrSm) ? 0 : 0,
        }}
      >
        <Typography className="section-heading" sx={{ mb: "0px !important" }}>
          All Applications
        </Typography>
        <FormControl
          variant="outlined"
          size="small"
          sx={{ minWidth: 120 }}
          className="view-all-dropdown"
        >
          <Select
            value={statusFilter}
            onChange={(e) => {
              setStatusFilter(e.target.value as string);
              setCurrentPage(1); // Reset to first page when filter changes
            }}
            displayEmpty
            inputProps={{ "aria-label": "Select status filter" }}
            sx={{
              borderRadius: "4px",
              "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e0e0e0" },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#dbdade",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#00b3b5",
                borderWidth: 1,
              },
            }}
          >
            <MenuItem value="all">
              <span className="value">All</span>
            </MenuItem>
            <MenuItem value="Submission Pending">
              <span className="value">Submission Pending</span>
            </MenuItem>
            <MenuItem value="Incomplete">
              <span className="value">Incomplete</span>
            </MenuItem>
            <MenuItem value="Query Pending">
              <span className="value">Query Pending</span>
            </MenuItem>
            <MenuItem value="Review In-Progress">
              <span className="value">Review In-Progress</span>
            </MenuItem>
            <MenuItem value="In-Progress">
              <span className="value">In-Progress</span>
            </MenuItem>
            <MenuItem value="Suspended">
              <span className="value">Suspended</span>
            </MenuItem>
            <MenuItem value="Disbursed">
              <span className="value">Disbursed</span>
            </MenuItem>
            <MenuItem value="Sanctioned">
              <span className="value">Sanctioned</span>
            </MenuItem>
            <MenuItem value="Declined by Credit">
              <span className="value">Declined by Credit</span>
            </MenuItem>
            <MenuItem value="Underwriting In-Progress">
              <span className="value">Underwriting In-Progress</span>
            </MenuItem>
            <MenuItem value="Application Rejected">
              <span className="value">Application Rejected</span>
            </MenuItem>
            <MenuItem value="Application Closed">
              <span className="value">Application Closed</span>
            </MenuItem>
          </Select>
        </FormControl>
      </Box>

      {/* Pagination */}
      {!isSliderLoading && totalApplications > 0 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            mb: 2,
            gap: 2,
          }}
        >
          <Typography variant="body2" sx={{ color: "#666" }}>
            {`${(currentPage - 1) * itemsPerPage + 1}-${Math.min(
              currentPage * itemsPerPage,
              totalApplications
            )} of ${totalApplications}`}
          </Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            <MUIIconButton
              size="small"
              onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
              disabled={currentPage === 1}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
                "&:disabled": { opacity: 0.3 },
              }}
            >
              <ArrowBackIosNewIcon fontSize="small" />
            </MUIIconButton>
            <MUIIconButton
              size="small"
              onClick={() =>
                setCurrentPage((prev) => Math.min(totalPages, prev + 1))
              }
              disabled={currentPage >= totalPages}
              sx={{
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
                "&:disabled": { opacity: 0.3 },
              }}
            >
              <ArrowForwardIosIcon fontSize="small" />
            </MUIIconButton>
          </Box>
        </Box>
      )}

      {/* List of Application Cards */}
      {isSliderLoading ? (
        [1, 2].map((item) => (
          <Box
            key={item}
            data-submission-id={`loading-${item}`}
            sx={{
              textAlign: "center",
              width: "100%",
              margin: "0 auto",
              maxWidth: {
                xs: "min(95vw, 380px)",
                sm: "min(95vw, 380px)",
                md: 900,
                lg: 1350,
                xl: 1780,
              },
              overflowX: "hidden",
            }}
          >
            <div className="card-contaner">
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                flexWrap="wrap"
                gap={2}
                mb={1}
                sx={{
                  px: 1,
                  boxSizing: "border-box",
                  width: "100%",
                }}
              >
                {/* Left Title and Status */}
                <Box display="flex" alignItems="center" gap={1} flexShrink={1}>
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: "2rem" }}
                    width={300}
                  />
                </Box>

                {/* Right Action Buttons */}
                <Box
                  display="flex"
                  gap={1.5}
                  flexWrap="wrap"
                  justifyContent="flex-end"
                  alignItems="center"
                  flexShrink={0}
                >
                  <Skeleton
                    variant="rectangular"
                    width={150}
                    height={35}
                    sx={{ borderRadius: "8px" }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width={120}
                    height={35}
                    sx={{ borderRadius: "8px" }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width={80}
                    height={35}
                    sx={{ borderRadius: "8px" }}
                  />
                </Box>
              </Box>

              {/* Application Details */}
              <Skeleton height={2} width="100%" sx={{ my: 2 }} />
              <Grid container spacing={3} sx={{ my: 2 }}>
                <Grid item xs={12} md={8}>
                  <Skeleton
                    variant="text"
                    sx={{ fontSize: "1.2rem", mb: 2 }}
                    width={200}
                  />
                  <Grid container rowSpacing={2} columnSpacing={4}>
                    {Array.from({ length: 8 }).map((_, index) => (
                      <Grid
                        item
                        xs={6}
                        sm={3}
                        key={index}
                        sx={{ textAlign: "left" }}
                      >
                        <Skeleton
                          variant="text"
                          sx={{ fontSize: "1rem" }}
                          width="80%"
                        />
                        <Skeleton
                          variant="text"
                          sx={{ fontSize: "1rem" }}
                          width="60%"
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
                <Grid item xs={12} md={4}>
                  <div className="right-side-box">
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 1,
                      }}
                    >
                      <Skeleton
                        variant="rectangular"
                        width={24}
                        height={24}
                        sx={{ mr: 1, borderRadius: "5px" }}
                      />
                      <Skeleton
                        variant="text"
                        sx={{ fontSize: "1.1rem" }}
                        width="80%"
                      />
                    </Box>
                    <Grid container spacing={2} sx={{ textAlign: "left" }}>
                      {Array.from({ length: 4 }).map((_, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                          <Skeleton
                            variant="text"
                            sx={{ fontSize: "0.9rem" }}
                            width="70%"
                          />
                          <Skeleton
                            variant="text"
                            sx={{ fontSize: "1rem" }}
                            width="50%"
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </div>
                </Grid>
              </Grid>

              {/* Application Progress */}
              <Skeleton height={2} width="100%" sx={{ my: 2 }} />
              <Skeleton
                variant="text"
                sx={{ fontSize: "1.2rem", mb: 2 }}
                width={200}
              />
              <Stepper
                activeStep={0}
                connector={
                  <Skeleton
                    variant="text"
                    width={50}
                    height={5}
                    sx={{ mx: 1 }}
                  />
                }
                sx={{ mb: 2 }}
              >
                {Array.from({ length: 6 }).map((_, index) => (
                  <Step key={index}>
                    <Box display="flex" flexDirection={"column"}>
                      <Skeleton
                        variant="rectangular"
                        width={25}
                        height={25}
                        sx={{ borderRadius: "5px" }}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          mt: 2,
                        }}
                      >
                        <Skeleton
                          variant="text"
                          sx={{ fontSize: "0.7rem" }}
                          width={90}
                        />
                        <Skeleton
                          variant="text"
                          sx={{ fontSize: "0.6rem" }}
                          width={70}
                        />
                      </Box>
                    </Box>
                  </Step>
                ))}
              </Stepper>
            </div>
          </Box>
        ))
      ) : !isSliderLoading && applications.length === 0 ? (
        <div className="card-contaner" data-submission-id="no-data">
          <Typography className="no-data-found">
            No existing application found!
          </Typography>
        </div>
      ) : (
        applications.map((app, index) => {
          const finalSteps = getCombinedApplicationSteps(app, app?.status);
          const activeStep = findActiveStep(finalSteps);
          const allFields = app?.horizontalSteps[0].verticalSteps[1]?.fields;
          const data = allFields?.find((f: any) => f.admissionStatus?.toLowerCase() === "undecided");
          const country = allFields?.find((f: any) => f.country)?.country;
          const universityCountryId = allFields?.find((f: any) => f.universityCountryId)?.universityCountryId;
            if (data) {
              const isValid = checkUndecided(country, universityCountryId, app?.source, app?.isQualified, app?.horizontalSteps?.[1]?.verticalSteps[0]?.fields?.length);
              if(isValid) {
                finalSteps[0].isCompleted = false;
                finalSteps[0].status = "pending";
                finalSteps[0].isQualified = false;
                finalSteps[0].isEligible = null;
              }
            }

          return (
            <ApplicationCard
              key={app.submissionId || index}
              application={app}
              activeStep={activeStep}
              finalSteps={finalSteps}
              isXsOrSm={isXsOrSm}
              isIphoneSE={isIphoneSE}
              breData={breData?.[app.submissionId]}
              isSliderLoading={isSliderLoading}
              leadDetailsData={leadDetailsData}
              sanctionDetailsData={sanctionDetailsData}
              provisionalOffer={breData?.[app?.submissionId]?.Provisional_Offer}
            />
          );
        })
      )}
    </Grid>
  );
};

export default ViewAllApplications;
